function getWishlistData() {
  const dataElement = document.getElementById("wishlist-data");
  if (!dataElement) return { lists: [] };
  try {
    return JSON.parse(dataElement.textContent);
  } catch (error) {
    return { lists: [] };
  }
}

const WISHLIST_ACTIVE_LIST_STORAGE_KEY = "stelling:wishlist:active-list-id";

// Finder id'et på den liste, brugeren senest har valgt (huskes i localStorage).
// Falder tilbage til den første liste, hvis intet er gemt, eller hvis den
// gemte liste ikke længere findes.
function getActiveListId(wishlistData) {
  let storedId = null;
  try {
    storedId = localStorage.getItem(WISHLIST_ACTIVE_LIST_STORAGE_KEY);
  } catch (error) {
    storedId = null;
  }

  const lists = (wishlistData && wishlistData.lists) || [];
  if (storedId && lists.some((list) => list.id === storedId)) {
    return storedId;
  }

  return lists.length > 0 ? lists[0].id : null;
}

function setActiveListId(listId) {
  try {
    localStorage.setItem(WISHLIST_ACTIVE_LIST_STORAGE_KEY, listId);
  } catch (error) {
    // Safari i privat tilstand kan fejle her - vi fejler stille
  }
}

const WISHLIST_PENDING_ADD_STORAGE_KEY = "stelling:wishlist:pending-add";

// Gemmer hvilken vare kunden forsøgte at tilføje til ønskelisten, mens de
// ikke var logget ind, så den kan tilføjes automatisk, når kunden er
// logget ind igen (se applyPendingWishlistAddIfLoggedIn).
function setPendingWishlistAdd(productId, variantId) {
  try {
    localStorage.setItem(WISHLIST_PENDING_ADD_STORAGE_KEY, JSON.stringify({ productId, variantId }));
  } catch (error) {
    // Safari i privat tilstand kan fejle her - vi fejler stille
  }
}

function getPendingWishlistAdd() {
  try {
    const raw = localStorage.getItem(WISHLIST_PENDING_ADD_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function clearPendingWishlistAdd() {
  try {
    localStorage.removeItem(WISHLIST_PENDING_ADD_STORAGE_KEY);
  } catch (error) {
    // Safari i privat tilstand kan fejle her - vi fejler stille
  }
}

const LAST_VIEWED_PRODUCT_STORAGE_KEY = "stelling:last-viewed-product";

// Husker titel + URL på den senest besøgte produktside, så kunden nemt kan
// finde tilbage fra "Din konto"-siden (fx efter login via ønskeliste-
// pop-uppen, eller hvis de bare er forvildet ind på kontosiden).
function setLastViewedProduct(title, url) {
  try {
    localStorage.setItem(LAST_VIEWED_PRODUCT_STORAGE_KEY, JSON.stringify({ title, url }));
  } catch (error) {
    // Safari i privat tilstand kan fejle her - vi fejler stille
  }
}

function getLastViewedProduct() {
  try {
    const raw = localStorage.getItem(LAST_VIEWED_PRODUCT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

// Tjekker om varen findes i den AKTIVE liste (ikke bare en hvilken som
// helst liste), så hjertets tilstand matcher hvad et klik rent faktisk gør.
function isInWishlist(wishlistData, productId, variantId, listId) {
  const targetListId = listId || getActiveListId(wishlistData);
  const list = wishlistData.lists.find((l) => l.id === targetListId);
  if (!list) return false;

  return list.items.some(
    (item) => String(item.product_id) === String(productId) && String(item.variant_id) === String(variantId)
  );
}

// Henter det AKTUELT VISTE varenavn i DOM'en (som langify kan have oversat),
// i stedet for det rå data-title-attribut - langify oversætter kun synlig
// tekst, aldrig HTML-attributter, så data-title forbliver altid dansk.
// Bruges alle steder, hvor et varenavn skal vises i en advarsel/pop-up.
function getWishlistItemDisplayTitle(itemElement, titleSelector) {
  if (!itemElement) return "Varen";
  const titleElement = itemElement.querySelector(titleSelector);
  const liveText = titleElement ? titleElement.textContent.trim() : "";
  return liveText || itemElement.dataset.title || "Varen";
}

// Egne bekræft- og indtast-dialoger bygget i siden selv, i stedet for
// browserens indbyggede dialoger, som mange app-webviews (fx Little
// Beacon-appen) slet ikke viser og i stedet stille afviser.
let wishlistDialogStylesInjected = false;

function injectWishlistDialogStyles() {
  if (wishlistDialogStylesInjected) return;
  wishlistDialogStylesInjected = true;

  const style = document.createElement("style");
  style.textContent = `
    .wishlist-dialog-overlay {
      position: fixed;
      inset: 0;
      background: rgba(20, 20, 20, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2147483647;
      padding: 1.5rem;
    }
    .wishlist-dialog {
      background: #f7f4ee;
      color: #1f1f1f;
      max-width: 400px;
      width: 100%;
      padding: 1.75rem 1.5rem 1.5rem;
      border-radius: 10px;
      text-align: center;
    }
    .wishlist-dialog__message {
      margin: 0 0 1.25rem;
      font-size: 1rem;
    }
    .wishlist-dialog__input {
      width: 100%;
      box-sizing: border-box;
      padding: 0.65rem 0.8rem;
      margin-bottom: 1.25rem;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      font: inherit;
      background: #ffffff;
      color: inherit;
    }
    .wishlist-dialog__buttons {
      display: flex;
      gap: 0.75rem;
      justify-content: center;
    }
    .wishlist-dialog__button {
      border: none;
      border-radius: 6px;
      padding: 0.7rem 1.4rem;
      font: inherit;
      font-size: 0.9rem;
      cursor: pointer;
    }
    .wishlist-dialog__button--cancel {
      background: transparent;
      color: #1f1f1f;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .wishlist-dialog__button--ok {
      background: #1a7a4c;
      color: #ffffff;
    }
  `;
  document.head.appendChild(style);
}

function showWishlistDialog({ message, withInput = false, defaultValue = "" }) {
  injectWishlistDialogStyles();

  return new Promise((resolve) => {
    // Er ønskeliste-skuffen åben, lægges dialogen INDE i den, så klik i
    // dialogen ikke tæller som "klik udenfor" og lukker skuffen.
    const host = document.querySelector("#wishlist-drawer[open]") || document.body;

    const overlay = document.createElement("div");
    overlay.className = "wishlist-dialog-overlay";
    overlay.innerHTML = `
      <div class="wishlist-dialog" role="dialog" aria-modal="true">
        <p class="wishlist-dialog__message"></p>
        ${withInput ? '<input type="text" class="wishlist-dialog__input">' : ""}
        <div class="wishlist-dialog__buttons">
          <button type="button" class="wishlist-dialog__button wishlist-dialog__button--cancel">Annuller</button>
          <button type="button" class="wishlist-dialog__button wishlist-dialog__button--ok">OK</button>
        </div>
      </div>
    `;

    // Teksten sættes via textContent, så varenavne aldrig tolkes som HTML.
    overlay.querySelector(".wishlist-dialog__message").textContent = message;
    const input = overlay.querySelector(".wishlist-dialog__input");
    if (input) input.value = defaultValue || "";

    overlay.addEventListener("pointerdown", (event) => event.stopPropagation());
    overlay.addEventListener("click", (event) => event.stopPropagation());

    const finish = (result) => {
      overlay.remove();
      resolve(result);
    };

    overlay.querySelector(".wishlist-dialog__button--cancel").addEventListener("click", () => {
      finish(withInput ? null : false);
    });

    overlay.querySelector(".wishlist-dialog__button--ok").addEventListener("click", () => {
      finish(withInput ? input.value : true);
    });

    if (input) {
      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          finish(input.value);
        }
      });
    }

    host.appendChild(overlay);

    if (input) {
      input.focus();
      input.select();
    } else {
      overlay.querySelector(".wishlist-dialog__button--ok").focus();
    }
  });
}

// Samme svar som de indbyggede dialoger: true/false for bekræft,
// tekst eller null (annulleret) for indtast.
function wishlistConfirm(message) {
  return showWishlistDialog({ message });
}

function wishlistPrompt(message, defaultValue) {
  return showWishlistDialog({ message, withInput: true, defaultValue });
}

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-wishlist-heart]");
  if (!button) return;

  const productId = button.dataset.productId;
  const variantId = button.dataset.variantId;

  // Ikke logget ind: #wishlist-data-øen renderes kun for indloggede kunder
  // (se layout/theme.liquid), så dens fravær er vores signal om at kunden
  // skal logges ind/oprette konto, før varen kan tilføjes.
  if (!document.getElementById("wishlist-data")) {
    showWishlistLoginPrompt(productId, variantId);
    return;
  }

  const activeListId = getActiveListId(getWishlistData());

  const svg = button.querySelector("svg");
  const label = button.querySelector(".wishlist-heart__label");

  const isActive = button.classList.toggle("wishlist-heart--active");

  if (isActive) {
    svg.setAttribute("fill", "currentColor");
    if (label) label.textContent = "Fjern fra ønskeliste";
    button.setAttribute("aria-label", "Fjern fra ønskeliste");
  } else {
    svg.setAttribute("fill", "none");
    if (label) label.textContent = "Føj til ønskeliste";
    button.setAttribute("aria-label", "Tilføj til ønskeliste");
  }

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: productId, variantId: variantId, listId: activeListId }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    const updatedWishlist = await response.json();
    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) {
      dataElement.textContent = JSON.stringify(updatedWishlist);
    }

    // Vis samme bekræftelses-pop-up som når en ventende vare tilføjes
    // automatisk efter login (se applyPendingWishlistAddIfLoggedIn) - men nu
    // ved ETHVERT hjerte-klik, der reelt tilføjer (ikke fjerner) en vare.
    if (isActive) {
      showWishlistPopup({
        message: "Varen er tilføjet til din ønskeliste",
        variant: "success",
      });
    }
  } catch (error) {
    console.error("Kunne ikke opdatere ønskeliste:", error);
  }
});

function syncWishlistHeartState() {
  const heart = document.querySelector("[data-wishlist-heart]");
  if (!heart) return;

  const wishlistData = getWishlistData();
  const isActive = isInWishlist(wishlistData, heart.dataset.productId, heart.dataset.variantId);

  const svg = heart.querySelector("svg");
  const label = heart.querySelector(".wishlist-heart__label");

  heart.classList.toggle("wishlist-heart--active", isActive);
  svg.setAttribute("fill", isActive ? "currentColor" : "none");
  if (label) label.textContent = isActive ? "Fjern fra ønskeliste" : "Føj til ønskeliste";
  heart.setAttribute("aria-label", isActive ? "Fjern fra ønskeliste" : "Tilføj til ønskeliste");
}

document.addEventListener("variant:change", (event) => {
  const heart = document.querySelector("[data-wishlist-heart]");
  if (!heart) return;

  heart.dataset.variantId = event.detail.variant.id;
  syncWishlistHeartState();
});

let wishlistLoginPromptStylesInjected = false;

// CSS'en indsættes kun i DOM'en første gang, pop-up'en faktisk skal vises -
// ligesom resten af filen bygger den selv i JS, i stedet for at kræve en
// separat <style>-blok i Liquid-filen.
function injectWishlistLoginPromptStyles() {
  if (wishlistLoginPromptStylesInjected) return;
  wishlistLoginPromptStylesInjected = true;

  const style = document.createElement("style");
  style.textContent = `
    @keyframes wishlistLoginPromptFadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes wishlistLoginPromptScaleIn {
      from { opacity: 0; transform: scale(0.94) translateY(8px); }
      to { opacity: 1; transform: scale(1) translateY(0); }
    }
    .wishlist-login-prompt-overlay {
      position: fixed;
      inset: 0;
      background: rgba(20, 20, 20, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2147483647;
      padding: 1.5rem;
      animation: wishlistLoginPromptFadeIn 0.2s ease;
    }
    .wishlist-login-prompt {
      position: relative;
      background: #f7f4ee;
      color: #1f1f1f;
      max-width: 420px;
      width: 100%;
      padding: 2.5rem 2rem;
      text-align: center;
      border-radius: 10px;
      animation: wishlistLoginPromptScaleIn 0.25s ease;
    }
    .wishlist-login-prompt__close {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      background: none;
      border: none;
      font-size: 1.5rem;
      line-height: 1;
      cursor: pointer;
      color: inherit;
      padding: 0.25rem;
      transition: color 0.15s ease, transform 0.15s ease;
    }
    .wishlist-login-prompt__close:hover {
      color: #000;
      transform: scale(1.1);
    }
    .wishlist-login-prompt__message {
      font-size: 1.15rem;
      margin: 0 0 1.5rem;
    }
    .wishlist-login-prompt__login-button {
      display: inline-block;
      background: #1a7a4c;
      color: #fff;
      border: none;
      border-radius: 6px;
      padding: 0.9rem 2rem;
      font-size: 0.95rem;
      text-decoration: none;
      cursor: pointer;
      margin-bottom: 1.25rem;
      transition: background-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
    }
    .wishlist-login-prompt__login-button:hover {
      background: #156340;
      transform: translateY(-1px);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }
    .wishlist-login-prompt__login-button:active {
      transform: translateY(0);
      box-shadow: none;
    }
    .wishlist-login-prompt__register {
      font-size: 0.9rem;
      margin: 0;
      color: #1f1f1f;
    }
    .wishlist-login-prompt__register button {
      background: none;
      border: none;
      padding: 0;
      font: inherit;
      color: #1a7a4c;
      text-decoration: underline;
      cursor: pointer;
      transition: color 0.15s ease;
    }
    .wishlist-login-prompt__register button:hover {
      color: #156340;
    }
  `;
  document.head.appendChild(style);
}

// Viser en pop-up, når en ikke-logget-ind kunde klikker hjertet. Stilen er
// et bevidst midtpunkt mellem Klaviyo-appens "SPAR 10%"-popup (cremefarvet
// boks, mørk overlay, centreret) og den rigtige log ind-side (grøn/blå
// farverne derfra) - koden fra hverken Klaviyo-popup'en eller login-siden
// kan genbruges direkte, så det er en ny, selvstændig komponent.
function showWishlistLoginPrompt(productId, variantId) {
  injectWishlistLoginPromptStyles();

  const existing = document.querySelector(".wishlist-login-prompt-overlay");
  if (existing) existing.remove();

  const returnUrl = window.location.pathname + window.location.search;

  const overlay = document.createElement("div");
  overlay.className = "wishlist-login-prompt-overlay";
  overlay.innerHTML = `
    <div class="wishlist-login-prompt" role="dialog" aria-modal="true" aria-label="Log ind for at bruge ønskelister">
      <button type="button" class="wishlist-login-prompt__close" aria-label="Luk">&times;</button>
      <p class="wishlist-login-prompt__message">Du skal være logget ind for at bruge ønskelister</p>
      <button type="button" class="wishlist-login-prompt__login-button" data-wishlist-login-prompt-login>Log ind</button>
      <p class="wishlist-login-prompt__register">
        Har du ikke en konto?
        <button type="button" data-wishlist-login-prompt-register>Tilmeld dig kundeklubben</button>
      </p>
    </div>
  `;

  document.body.appendChild(overlay);

  const close = () => overlay.remove();

  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) close();
  });

  overlay.querySelector(".wishlist-login-prompt__close").addEventListener("click", close);

  overlay.querySelector("[data-wishlist-login-prompt-login]").addEventListener("click", () => {
    setPendingWishlistAdd(productId, variantId);
    // Nye kundekonti: return_to på /customer_authentication/login sender
    // kunden tilbage til den side, de kom fra (kun relative stier).
    window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(returnUrl)}`;
  });

  overlay.querySelector("[data-wishlist-login-prompt-register]").addEventListener("click", () => {
    setPendingWishlistAdd(productId, variantId);
    window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(returnUrl)}`;
  });
}

// Tjekkes ved hver sideindlæsning: hvis kunden har et "ventende" forsøg på
// at tilføje en vare til ønskelisten (fra før login/tilmelding), og kunden
// nu ER logget ind, tilføjes varen automatisk, og der vises en bekræftelse.
async function applyPendingWishlistAddIfLoggedIn() {
  const pending = getPendingWishlistAdd();
  if (!pending) return;

  // Stadig ikke logget ind (fx hvis kunden lukkede pop-up'en uden at logge
  // ind, og bare browser videre) - lad den ventende vare blive stående,
  // indtil kunden rent faktisk logger ind.
  if (!document.getElementById("wishlist-data")) return;

  clearPendingWishlistAdd();

  const activeListId = getActiveListId(getWishlistData());

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: pending.productId, variantId: pending.variantId, listId: activeListId }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    const updatedWishlist = await response.json();
    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) {
      dataElement.textContent = JSON.stringify(updatedWishlist);
    }

    syncWishlistHeartState();
    refreshWishlistAccountGrid();

    showWishlistPopup({
      message: "Varen er tilføjet til din ønskeliste",
      variant: "success",
    });
  } catch (error) {
    console.error("Kunne ikke tilføje ventende vare til ønskeliste:", error);
  }
}

// Kør også ved sideindlæsning, så hjertet matcher den aktive liste med det
// samme - Liquid ved ikke, hvilken liste der er valgt i localStorage, når
// siden renderes server-side, så dette retter tilstanden øjeblikkeligt.
syncWishlistHeartState();
applyPendingWishlistAddIfLoggedIn();

// Registrerer den aktuelle side som "senest sete vare", hvis det er en
// produktside. Bruger sidens eneste <h1> som titel (produktsidens
// overskrift) - en pragmatisk løsning uden at skulle ændre i Liquid-koden.
if (window.location.pathname.includes("/products/")) {
  const heading = document.querySelector("h1");
  if (heading && heading.textContent.trim()) {
    setLastViewedProduct(heading.textContent.trim(), window.location.href);
  }
}

// Viser "Vend tilbage til ..."-linket øverst på "Din konto"-siden, hvis der
// findes en gemt "senest sete vare" - ellers forbliver linket skjult (det
// har `hidden` som standard i Liquid-markup'en).
function initWishlistLastViewedLink() {
  const link = document.querySelector("[data-wishlist-last-viewed-link]");
  if (!link) return;

  const lastViewed = getLastViewedProduct();
  if (!lastViewed) return;

  // "Vend tilbage til" ligger nu som fast tekst i selve Liquid-markuppen
  // (så langify kan oversætte den ligesom al anden statisk tekst) - her
  // sættes kun selve varenavnet ind, i sin egen, uoversatte <span>.
  const label = link.querySelector("[data-wishlist-last-viewed-label]");
  if (label) label.textContent = lastViewed.title;
  link.href = lastViewed.url;
  link.hidden = false;
}
initWishlistLastViewedLink();

// Koala Bundles-appen ("Vælg en pakke", custom element <koala-quantity-breaks-embed>,
// app-blok-id indeholder "upsell_koala_bundles_bundle_app_block") sætter
// style="display:none" på HELE .product-info__block-item[data-block-type="quantity-selector"]
// -wrapperen i product-info.liquid (ikke kun selve <quantity-selector>-elementet) - og
// da hjertet ligger i samme blok (i .wishlist-quantity-row), bliver det skjult med.
// Denne funktion opdager det og flytter selve hjerte-knappen (ikke en kopi) ind i
// "Læg i kurv"-blokken i stedet, så den forbliver synlig og klikbar.
function relocateWishlistHeartIfQuantityBlockHidden() {
  const heart = document.querySelector("[data-wishlist-heart]");
  if (!heart) return;

  const quantityBlock = heart.closest('.product-info__block-item[data-block-type="quantity-selector"]');
  const buyButtonsBlock = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
  if (!quantityBlock || !buyButtonsBlock) return;

  const isHidden = window.getComputedStyle(quantityBlock).display === "none";
  if (!isHidden) return;
  if (buyButtonsBlock.contains(heart)) return;

  heart.style.marginBottom = "12px";
  buyButtonsBlock.prepend(heart);
}

// Tre-lags forsvarsmønster: (1) øjeblikkeligt tjek ved opstart, (2) en
// MutationObserver på .product-info (fanger både at appen selv sætter
// display:none, og temaets genopbygning af blokke ved variantskift), og
// (3) et periodisk setInterval-sikkerhedsnet.
relocateWishlistHeartIfQuantityBlockHidden();

const productInfoElement = document.querySelector(".product-info");
if (productInfoElement) {
  const wishlistHeartRelocateObserver = new MutationObserver(() => {
    relocateWishlistHeartIfQuantityBlockHidden();
  });
  wishlistHeartRelocateObserver.observe(productInfoElement, {
    attributes: true,
    childList: true,
    subtree: true,
  });
}

setInterval(relocateWishlistHeartIfQuantityBlockHidden, 500);

document.addEventListener("click", async (event) => {
  const trigger = event.target.closest("#openWishlistDrawer");
  if (!trigger) return;

  const emptyState = document.querySelector("[data-wishlist-empty]");
  const itemsContainer = document.querySelector("[data-wishlist-items]");
  if (!emptyState || !itemsContainer) return;

  try {
    const response = await fetch("/apps/onskeliste");
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    const wishlist = await response.json();
    renderWishlistDrawer(wishlist, emptyState, itemsContainer);
  } catch (error) {
    console.error("Kunne ikke hente ønskeliste:", error);
  }
});

function renderWishlistDrawer(wishlist, emptyState, itemsContainer) {
  // Enhver fuld gentegning starter med ingen markerede varer (de nye
  // checkbokse renderes altid umarkerede) - skjul derfor altid bulk-
  // handlingslinjen igen her, uanset om den var synlig lige inden.
  const bulkActionsBar = document.querySelector("[data-wishlist-bulk-actions]");
  if (bulkActionsBar) bulkActionsBar.hidden = true;

  const listSelect = document.querySelector("[data-wishlist-list-select]");
  const activeListId = getActiveListId(wishlist);

  if (listSelect) {
    listSelect.innerHTML = wishlist.lists
      .map((list) => `<option value="${list.id}"${list.id === activeListId ? " selected" : ""}>${list.name}</option>`)
      .join("");
  }

  const activeList = wishlist.lists.find((list) => list.id === activeListId);
  const items = activeList ? activeList.items : [];

  if (items.length === 0) {
    emptyState.hidden = false;
    itemsContainer.hidden = true;
    itemsContainer.innerHTML = "";
    return;
  }

  emptyState.hidden = true;
  itemsContainer.hidden = false;

  const cartIconTemplate = document.getElementById("wishlist-cart-icon-template");
  const cartIconHtml = cartIconTemplate ? cartIconTemplate.innerHTML : "";

  const otherLists = wishlist.lists.filter((list) => list.id !== activeListId);
  const moveToOptionsHtml = otherLists.map((list) => `<option value="${list.id}">${list.name}</option>`).join("");

  itemsContainer.innerHTML = items
    .map(
      (item) => `
       <div class="line-item wishlist-drawer__item${item.available === false ? " wishlist-item--sold-out" : ""}" data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" data-title="${item.title}">
          <div class="wishlist-drawer__item-actions" aria-hidden="true">
            <button type="button" class="wishlist-drawer__swipe-action wishlist-drawer__swipe-action--delete" data-wishlist-remove data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Fjern fra ønskeliste">
              <svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 16 16" width="18" height="18">
                <path d="M2 4h12M6 4V2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V4m2 0-.6 9.4a1 1 0 0 1-1 .9H4.6a1 1 0 0 1-1-.9L3 4M6.5 7v4M9.5 7v4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Slet</span>
            </button>
            ${otherLists.length > 0 ? `<span class="wishlist-drawer__swipe-action wishlist-drawer__swipe-action--move">
              <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" fill="none" width="18" height="18">
                <path d="M6 3 2 8l4 5M2 8h12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Flyt</span>
              <select class="wishlist-drawer__swipe-select" data-wishlist-move-to data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Flyt til anden ønskeliste">
                <option value="">Flyt til...</option>
                ${moveToOptionsHtml}
              </select>
            </span>` : ""}
            ${item.available === false ? "" : `<button type="button" class="wishlist-drawer__swipe-action wishlist-drawer__swipe-action--cart" data-wishlist-add-to-cart aria-label="Tilføj til kurv">
              ${cartIconHtml}
              <span>Kurv</span>
            </button>`}
          </div>

          <div class="wishlist-drawer__item-front">
            <button type="button" class="wishlist-drawer__drag-handle hover:animate-icon-block" aria-label="Træk for at ændre rækkefølge">
              <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" fill="none" width="16" height="16">
                <circle cx="5" cy="3" r="1" fill="currentColor"/>
                <circle cx="11" cy="3" r="1" fill="currentColor"/>
                <circle cx="5" cy="8" r="1" fill="currentColor"/>
                <circle cx="11" cy="8" r="1" fill="currentColor"/>
                <circle cx="5" cy="13" r="1" fill="currentColor"/>
                <circle cx="11" cy="13" r="1" fill="currentColor"/>
              </svg>
            </button>
            <div class="wishlist-drawer__image-wrap">
              <a href="${item.url}">
                <img src="${item.image}" alt="${item.title}" width="120" height="120" class="line-item__media">
              </a>
              <input type="checkbox" class="wishlist-select-checkbox" data-wishlist-select data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Vælg ${item.title}">
              ${item.available === false ? `<div class="wishlist-sold-out-overlay"></div>
              <svg class="wishlist-sold-out-line" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                <line x1="0" y1="0" x2="100" y2="100" vector-effect="non-scaling-stroke"></line>
              </svg>` : ""}
            </div>
            <div class="line-item-info">
              <div class="v-stack justify-items-start gap-2">
                <div class="v-stack justify-items-start gap-1">
                  <a href="${item.url}" class="wishlist-drawer__item-title">${item.title}</a>
                  ${item.variant_title && item.variant_title !== "Default Title" ? `<p class="smallcaps text-subdued">${item.variant_title}</p>` : ""}
                  <p>${item.price} kr.</p>
                </div>

                <div class="h-stack gap-4">
                  <div class="quantity-selector quantity-selector--sm">
                    <button type="button" class="quantity-selector__button" data-wishlist-qty-decrease data-product-id="${item.product_id}" data-variant-id="${item.variant_id}">−</button>
                    <div class="quantity-selector__input-wrapper">
                      <input class="quantity-selector__input" type="number" value="${item.quantity || 1}" min="1" data-wishlist-qty-input data-product-id="${item.product_id}" data-variant-id="${item.variant_id}">
                    </div>
                    <button type="button" class="quantity-selector__button" data-wishlist-qty-increase data-product-id="${item.product_id}" data-variant-id="${item.variant_id}">+</button>
                  </div>

                  ${item.available === false ? "" : `<button type="button" class="wishlist-add-to-cart wishlist-drawer__desktop-only" data-wishlist-add-to-cart aria-label="Tilføj til kurv">
  ${cartIconHtml}
  <span class="wishlist-add-to-cart__badge">+</span>
</button>`}

                  <button type="button" class="hover:animate-icon-block wishlist-drawer__desktop-only" data-wishlist-remove data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Fjern fra ønskeliste">
                    <svg aria-hidden="true" focusable="false" fill="none" class="icon" viewBox="0 0 16 16" style="width: 16px; height: 16px;">
                      <path d="M2 4h12M6 4V2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V4m2 0-.6 9.4a1 1 0 0 1-1 .9H4.6a1 1 0 0 1-1-.9L3 4M6.5 7v4M9.5 7v4" stroke="#a3a3a3" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>

                ${otherLists.length > 0 ? `<select class="wishlist-drawer__move-select wishlist-drawer__desktop-only" data-wishlist-move-to data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Flyt til anden ønskeliste">
                  <option value="">Flyt til...</option>
                  ${moveToOptionsHtml}
                </select>` : ""}
              </div>
            </div>
          </div>
        </div>
      `
    )
    .join("");

  initWishlistSortable(itemsContainer, activeListId);
  enableAllSwipeActions(itemsContainer);
  showSwipeHintForAll(itemsContainer);
}

let wishlistSortable = null;

function initWishlistSortable(itemsContainer, activeListId) {
  if (typeof Sortable === "undefined") return;

  if (wishlistSortable) {
    wishlistSortable.destroy();
    wishlistSortable = null;
  }

  wishlistSortable = Sortable.create(itemsContainer, {
    handle: ".wishlist-drawer__drag-handle",
    animation: 150,
    forceFallback: true,
    fallbackOnBody: true,
    fallbackTolerance: 3,
    onEnd: async () => {
      const orderedItems = Array.from(itemsContainer.querySelectorAll(".wishlist-drawer__item")).map((el) => ({
        productId: el.dataset.productId,
        variantId: el.dataset.variantId,
      }));

      try {
        const response = await fetch("/apps/onskeliste", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "reorderItems", listId: activeListId, orderedItems: orderedItems }),
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
        }

        const updatedWishlist = await response.json();
        const dataElement = document.getElementById("wishlist-data");
        if (dataElement) {
          dataElement.textContent = JSON.stringify(updatedWishlist);
        }
      } catch (error) {
        console.error("Kunne ikke gemme ny rækkefølge:", error);
      }
    },
  });
}

// iOS-agtig "elastisk" dæmpning: jo længere man trækker forbi grænsen,
// jo mere modstand føles der (aftagende bevægelse i stedet for hårdt stop).
function applyRubberBand(distanceBeyondLimit, referenceSize) {
  return (distanceBeyondLimit * referenceSize) / (referenceSize + distanceBeyondLimit);
}

function enableSwipeAction(itemElement, shouldPeek) {
  const front = itemElement.querySelector(".wishlist-drawer__item-front");
  const actionsPanel = itemElement.querySelector(".wishlist-drawer__item-actions");
  if (!front || !actionsPanel) return;

  const buttonCount = actionsPanel.children.length;
  const OPEN_WIDTH_PER_BUTTON = 76;
  const revealDistance = () => buttonCount * OPEN_WIDTH_PER_BUTTON;
  const commitDistance = () => revealDistance() + front.offsetWidth * 0.4;

  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let swipeDecided = false;
  let horizontalSwipe = false;
  let isOpen = false;
  let isTracking = false;

  const setOffset = (offset) => {
    front.style.transform = `translateX(${offset}px)`;
    actionsPanel.style.width = `${Math.min(-offset, revealDistance())}px`;
  };

  front.addEventListener("touchstart", (event) => {
    if (event.target.closest(".wishlist-drawer__drag-handle, select, input")) {
      isTracking = false;
      return;
    }
    if (event.touches.length !== 1) {
      isTracking = false;
      return;
    }

    isTracking = true;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
    currentX = startX;
    swipeDecided = false;
    horizontalSwipe = false;
    front.style.transition = "none";
    actionsPanel.style.transition = "none";
  }, { passive: true });

  front.addEventListener("touchmove", (event) => {
    if (!isTracking) return;

    currentX = event.touches[0].clientX;
    const deltaX = currentX - startX;
    const deltaY = event.touches[0].clientY - startY;

    if (!swipeDecided) {
      if (Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) return;
      swipeDecided = true;
      horizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
      if (!horizontalSwipe) return;
    }

    if (!horizontalSwipe) return;

    event.preventDefault();
    const base = isOpen ? -revealDistance() : 0;
    const raw = base + deltaX;

    let offset;
    if (raw >= -revealDistance()) {
      offset = Math.min(0, raw);
    } else {
      const extra = -revealDistance() - raw;
      const damped = applyRubberBand(extra, front.offsetWidth);
      offset = -revealDistance() - damped;
    }
    setOffset(offset);
  }, { passive: false });

  const finishSwipe = () => {
    if (!isTracking) return;
    isTracking = false;
    if (!horizontalSwipe) return;

    front.style.transition = "transform 0.2s ease";
    actionsPanel.style.transition = "width 0.2s ease";

    const base = isOpen ? -revealDistance() : 0;
    const deltaX = currentX - startX;
    const rawFinal = base + deltaX;

    if (-rawFinal > commitDistance()) {
      front.style.transform = `translateX(-${front.offsetWidth}px)`;
      actionsPanel.style.width = `${front.offsetWidth}px`;
      const cartButton = itemElement.querySelector(".wishlist-drawer__swipe-action--cart");
      setTimeout(() => {
        if (cartButton) cartButton.click();
      }, 200);
      return;
    }

    if (-rawFinal > revealDistance() * 0.4) {
      setOffset(-revealDistance());
      isOpen = true;
    } else {
      setOffset(0);
      isOpen = false;
    }
  };

  front.addEventListener("touchend", finishSwipe);
  front.addEventListener("touchcancel", finishSwipe);

  front.addEventListener("click", (event) => {
    if (isOpen) {
      event.preventDefault();
      front.style.transition = "transform 0.2s ease";
      actionsPanel.style.transition = "width 0.2s ease";
      setOffset(0);
      isOpen = false;
    }
  });

  // "Peek"-hint: viser kort en flig af handlingsknapperne ved automatisk at
  // trække varen en smule til venstre og tilbage igen, så swipe-funktionen
  // er tydelig uden at kræve tekst eller at brugeren selv opdager den.
  if (shouldPeek) {
    const PEEK_DISTANCE = 40;
    requestAnimationFrame(() => {
      front.style.transition = "transform 0.45s ease";
      actionsPanel.style.transition = "width 0.45s ease";
      setOffset(-PEEK_DISTANCE);

      setTimeout(() => {
        front.style.transition = "transform 0.45s ease";
        actionsPanel.style.transition = "width 0.45s ease";
        setOffset(0);
      }, 650);
    });
  }
}

function enableAllSwipeActions(itemsContainer) {
  const isMobile = window.matchMedia("(max-width: 699px)").matches;
  const items = itemsContainer.querySelectorAll(".wishlist-drawer__item");
  items.forEach((itemElement, index) => {
    enableSwipeAction(itemElement, isMobile && index === 0);
  });
}

function showSwipeHint(itemElement) {
  const front = itemElement.querySelector(".wishlist-drawer__item-front");
  if (!front) return;

  const arrow = document.createElement("div");
  arrow.className = "wishlist-drawer__swipe-hint-arrow";
  arrow.innerHTML = `
    <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" fill="none" width="18" height="18">
      <path d="M10 3 4 8l6 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  front.appendChild(arrow);

  requestAnimationFrame(() => {
    arrow.classList.add("is-visible");
  });
}


function showSwipeHintForAll(itemsContainer) {
  if (!window.matchMedia("(max-width: 699px)").matches) return;

  const items = itemsContainer.querySelectorAll(".wishlist-drawer__item");
  items.forEach((item) => showSwipeHint(item));
}

document.addEventListener("click", async (event) => {
  const removeButton = event.target.closest("[data-wishlist-remove]");
  if (!removeButton) return;

  const itemElement = removeButton.closest(".wishlist-drawer__item");
  if (!itemElement) return;

  const productId = removeButton.dataset.productId;
  const variantId = removeButton.dataset.variantId;
  const title = getWishlistItemDisplayTitle(itemElement, ".wishlist-drawer__item-title");
  const listId = getActiveListId(getWishlistData());

  const confirmed = await wishlistConfirm(`Er du sikker på du vil fjerne "${title}" fra din ønskeliste?`);
  if (!confirmed) return;

  // Fjern varen visuelt med det samme.
  itemElement.remove();

  const itemsContainer = document.querySelector("[data-wishlist-items]");
  const emptyState = document.querySelector("[data-wishlist-empty]");
  if (itemsContainer && itemsContainer.children.length === 0) {
    itemsContainer.hidden = true;
    if (emptyState) emptyState.hidden = false;
  }

  // Selve sletningen sker på serveren MED DET SAMME (ikke længere udskudt
  // til fortryd-toastens timer løber ud) - forlader kunden siden inden
  // timeren udløber, betyder det derfor ikke længere at sletningen går tabt
  // uden virkning. "Fortryd" gen-tilføjer i stedet varen, hvis kunden
  // fortryder i tide.
  try {
    await removeItemFromWishlistData(productId, variantId, listId);
  } catch (error) {
    console.error("Kunne ikke fjerne vare:", error);
  }

  showWishlistPopup({
    messageParts: [
      { text: title, dynamic: true },
      { text: " er fjernet fra din ønskeliste." },
    ],
    actionText: "Fortryd",
    variant: "error",
    onAction: async () => {
      try {
        await readdWishlistItemToWishlistData(productId, variantId, listId);

        const restoredEmptyState = document.querySelector("[data-wishlist-empty]");
        const restoredItemsContainer = document.querySelector("[data-wishlist-items]");
        if (restoredEmptyState && restoredItemsContainer) {
          renderWishlistDrawer(getWishlistData(), restoredEmptyState, restoredItemsContainer);
        }
      } catch (error) {
        console.error("Kunne ikke fortryde fjernelse:", error);
      }
    },
  });
});

document.addEventListener("click", async (event) => {
  const decreaseButton = event.target.closest("[data-wishlist-qty-decrease]");
  const increaseButton = event.target.closest("[data-wishlist-qty-increase]");
  const button = decreaseButton || increaseButton;
  if (!button) return;

  const wrapper = button.closest(".quantity-selector");
  const input = wrapper.querySelector("[data-wishlist-qty-input]");
  let newQuantity = parseInt(input.value, 10) || 1;

  if (decreaseButton) newQuantity = Math.max(1, newQuantity - 1);
  if (increaseButton) newQuantity = newQuantity + 1;

  input.value = newQuantity;
  await updateWishlistItemQuantity(input.dataset.productId, input.dataset.variantId, newQuantity);
});

document.addEventListener("change", async (event) => {
  const input = event.target.closest("[data-wishlist-qty-input]");
  if (!input) return;

  let newQuantity = parseInt(input.value, 10);
  if (!newQuantity || newQuantity < 1) newQuantity = 1;
  input.value = newQuantity;

  await updateWishlistItemQuantity(input.dataset.productId, input.dataset.variantId, newQuantity);
});

async function updateWishlistItemQuantity(productId, variantId, quantity) {
  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "setQuantity", productId: productId, variantId: variantId, quantity: quantity }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    const updatedWishlist = await response.json();
    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) {
      dataElement.textContent = JSON.stringify(updatedWishlist);
    }
  } catch (error) {
    console.error("Kunne ikke opdatere antal:", error);
  }
}

document.addEventListener("click", async (event) => {
  const addButton = event.target.closest("[data-wishlist-add-to-cart]");
  if (!addButton) return;

  const itemElement = addButton.closest(".wishlist-drawer__item");
  if (!itemElement) return;

  const variantId = itemElement.dataset.variantId;
  const title = itemElement.dataset.title;
  const quantityInput = itemElement.querySelector("[data-wishlist-qty-input]");
  const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || "Kunne ikke tilføje til kurv");
    }

       // Vis popup'en med det samme, når "læg i kurv" er bekræftet - i stedet
    // for at vente på at kurv-skuffen er opdateret bagefter. Det er derfor
    // popup'en før virkede forsinket.
    showWishlistPopup({
      messageParts: [
        { text: quantity, dynamic: true },
        { text: " × " },
        { text: title, dynamic: true },
        { text: " tilføjet til kurv." },
      ],
      linkHref: "/cart",
      linkText: "Se indkøbskurv",
      linkAriaControls: "cart-drawer",
      variant: "success",
    });

    const sectionId = getCartDrawerSectionId();
    const cartContent = await fetchCartWithSection(sectionId);

    // Send PRÆCIS samme event som temaets egen "Læg i kurv"-knap sender
    // (se product-form.js -> onSubmit_fn). Det er dette event, <cart-drawer>
    // selv lytter efter for at opdatere sit indhold (se cart-drawer.js ->
    // onCartChange_fn/replaceContent_fn) - så vi undgår vores eget parallelle
    // opdaterings-system. cart-count/cart-dot/free-shipping-bar lytter også
    // efter samme event og opdaterer sig selv automatisk.
    // baseEvent er "line-item:change" og ikke "variant:add", fordi
    // <cart-drawer>'s indbyggede logik kun åbner skuffen automatisk ved
    // "variant:add" - her bevarer vi den eksisterende adfærd, hvor skuffen
    // IKKE popper op af sig selv (brugeren ser toast'en ovenfor i stedet).
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "line-item:change",
        cart: cartContent,
      },
    }));

    const productId = itemElement.dataset.productId;
    await removeItemFromWishlistData(productId, variantId);

    itemElement.classList.add("wishlist-drawer__item--added");
    itemElement.innerHTML = `
      <p class="wishlist-drawer__item-added-text">
        Produkt tilføjet til kurv.
        <a href="/cart" class="link" aria-controls="cart-drawer" data-no-instant>Se indkøbskurv</a>
      </p>
    `;
  } catch (error) {
    console.error("Kunne ikke tilføje til kurv:", error);
    showWishlistPopup({
      message: error.message,
      variant: "error",
    });
  }
});

function getThemeColorSchemeClass() {
  const drawer = document.getElementById("wishlist-drawer");
  if (!drawer) return "color-scheme";
  const schemeClass = Array.from(drawer.classList).find((cls) => cls.startsWith("color-scheme--"));
  return schemeClass ? `color-scheme ${schemeClass}` : "color-scheme";
}

// Bygger en toast-beskeds HTML ud fra en liste af dele. Hver del er enten
// statisk (almindelig dansk sidetekst, som langify oversætter ligesom alt
// andet indhold) eller dynamisk (et rå vare-/listenavn, som IKKE skal
// oversættes). De to typer holdes i hver sin <span>, så vi helt undgår
// langifys pladsholder-matching for sammensatte strenge - samme princip som
// Mål-popup'ens opsplitning af produktnavn + "Mål" i to selvstændige
// elementer, i stedet for én sammensat overskrift.
function buildWishlistToastMessageHtml(parts) {
  return parts
    .map((part) =>
      part.dynamic
        ? `<span class="wishlist-toast__value">${part.text}</span>`
        : `<span class="wishlist-toast__label">${part.text}</span>`
    )
    .join("");
}

function showWishlistPopup({ message, messageParts, linkHref, linkText, linkAriaControls, actionText, onAction, onTimeout, variant = "success", duration = 4000 }) {
  const existingToast = document.querySelector(".wishlist-toast");
  if (existingToast) existingToast.remove();

  const toast = document.createElement("div");
  toast.className = `wishlist-toast wishlist-toast--${variant} ${getThemeColorSchemeClass()}`;
  // messageParts bruges til beskeder med et vare-/listenavn i sig (se
  // kaldene længere nede) - almindelige rent statiske beskeder kan stadig
  // bruge "message" direkte, uændret.
  const messageHtml = messageParts ? buildWishlistToastMessageHtml(messageParts) : message;
  toast.innerHTML = `
    <button type="button" class="wishlist-toast__close" aria-label="Luk">&times;</button>
    <p>${messageHtml}</p>
    ${linkHref ? `<a href="${linkHref}" class="link" ${linkAriaControls ? `aria-controls="${linkAriaControls}" data-no-instant` : ""}>${linkText}</a>` : ""}
    ${actionText ? `<button type="button" class="link wishlist-toast__action">${actionText}</button>` : ""}
    <div class="wishlist-toast__timer" style="animation-duration: ${duration}ms;"></div>
  `;
  // Popup'en skal ligge INDE i en evt. åben skuffe, ikke direkte i <body> -
  // <x-drawer>/<cart-drawer> ser ud til at fange/blokere klik på alt uden
  // for deres eget indhold, mens de er åbne (formentlig indbygget
  // popover/dialog-adfærd), så et element sat direkte på <body> kan ikke
  // modtage klik, før skuffen lukkes. Ved at gøre popup'en til barn af den
  // åbne skuffe undgås problemet, uanset hvad den reelle årsag er.
  // Toasten skal ALTID ligge øverst, uanset om en skuffe (wishlist- eller
  // kurv-skuffe) er åben - derfor sat direkte på document.body (ikke inde i
  // en åben skuffe, som tidligere) OG med en eksplicit, meget høj z-index
  // sat via inline style, så den vinder over enhver skuffes egen z-index,
  // uanset dens konkrete værdi. stopPropagation herunder sørger stadig for,
  // at klik på selve toasten ikke lukker en åben skuffe (klik-udenfor).
  document.body.appendChild(toast);
  toast.style.zIndex = "2147483647";

  toast.addEventListener("pointerdown", (event) => event.stopPropagation());
  toast.addEventListener("click", (event) => event.stopPropagation());

  const timeoutId = setTimeout(() => {
    toast.remove();
    if (onTimeout) onTimeout();
  }, duration);

  const closeButton = toast.querySelector(".wishlist-toast__close");
  closeButton.addEventListener("click", () => {
    clearTimeout(timeoutId);
    toast.remove();
    if (onTimeout) onTimeout();
  });

  if (linkHref && linkAriaControls) {
    const overlayLink = toast.querySelector(`a[aria-controls="${linkAriaControls}"]`);
    if (overlayLink) {
      overlayLink.addEventListener("click", (event) => {
        const targetDrawer = document.getElementById(linkAriaControls);
        if (targetDrawer) {
          event.preventDefault();
          if (!targetDrawer.hasAttribute("open")) {
            targetDrawer.setAttribute("open", "");
          }
        }
      });
    }
  }

  if (actionText && onAction) {
    const actionButton = toast.querySelector(".wishlist-toast__action");
    actionButton.addEventListener("click", () => {
      clearTimeout(timeoutId);
      toast.remove();
      onAction();
    });
  }
}


async function fetchCartDrawerSectionHtml(sectionId) {
  if (!sectionId) {
    return null;
  }

  try {
    const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok) return null;

    const data = await response.json();
    return data[sectionId] || null;
  } catch (error) {
    console.error("Kunne ikke hente frisk kurv-HTML:", error);
    return null;
  }
}

// Cacher selve sektions-id'et (en tekststreng, som aldrig ændrer sig) -
// IKKE selve DOM-elementet, fordi #cart-drawer bliver flyttet ud af sin
// oprindelige wrapper-boks, når skuffen åbnes, hvilket ville ødelægge en
// DOM-baseret cache.
let cachedCartDrawerSectionId = null;

function getCartDrawerWrapper() {
  const cartDrawerElement = document.querySelector("cart-drawer");
  if (!cartDrawerElement) return null;
  return cartDrawerElement.closest('[id^="shopify-section-"], [id^="sections--"]');
}
function getCartDrawerSectionId() {
  if (cachedCartDrawerSectionId) {
    return cachedCartDrawerSectionId;
  }
  const wrapper = getCartDrawerWrapper();
  cachedCartDrawerSectionId = wrapper ? wrapper.id.replace("shopify-section-", "") : null;
  return cachedCartDrawerSectionId;
}

async function fetchCartWithSection(sectionId) {
  const [cartContent, sectionHtml] = await Promise.all([
    fetch("/cart.js").then((response) => response.json()),
    fetchCartDrawerSectionHtml(sectionId),
  ]);
  cartContent.sections = cartContent.sections || {};
  if (sectionId && sectionHtml) {
    cartContent.sections[sectionId] = sectionHtml;
  }
  return cartContent;
}

async function removeItemFromWishlistData(productId, variantId, listId) {
  const targetListId = listId || getActiveListId(getWishlistData());

  const response = await fetch("/apps/onskeliste", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ productId: productId, variantId: variantId, listId: targetListId }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
  }

  const updatedWishlist = await response.json();
  const dataElement = document.getElementById("wishlist-data");
  if (dataElement) {
    dataElement.textContent = JSON.stringify(updatedWishlist);
  }

  const heartOnPage = document.querySelector(
    `[data-wishlist-heart][data-product-id="${productId}"][data-variant-id="${variantId}"]`
  );
  if (heartOnPage) {
    heartOnPage.classList.remove("wishlist-heart--active");
    const heartSvg = heartOnPage.querySelector("svg");
    const heartLabel = heartOnPage.querySelector(".wishlist-heart__label");
    if (heartSvg) heartSvg.setAttribute("fill", "none");
    if (heartLabel) heartLabel.textContent = "Føj til ønskeliste";
    heartOnPage.setAttribute("aria-label", "Tilføj til ønskeliste");
  }

  return updatedWishlist;
}

// Gen-tilføjer en vare, der lige er blevet fjernet, når kunden trykker
// "Fortryd" (bruges af fjern-vare-klik-lytterne for både skuffen og
// kontosiden). "/apps/onskeliste" er reelt et toggle-endpoint (samme kald
// bruges til både at tilføje OG fjerne en vare, afhængig af om den allerede
// findes på listen) - da varen lige er fjernet, tilføjer et nyt kald med
// samme produkt/variant/liste den bare igen. listId SKAL være den liste,
// varen oprindeligt blev fjernet fra (ikke nødvendigvis den aktive liste
// lige nu, hvis kunden skulle nå at skifte liste, mens fortryd-toasten var
// synlig) - derfor sendes den altid eksplicit med, i stedet for at blive
// genberegnet her.
async function readdWishlistItemToWishlistData(productId, variantId, listId) {
  const response = await fetch("/apps/onskeliste", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ productId: productId, variantId: variantId, listId: listId }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
  }

  const updatedWishlist = await response.json();
  const dataElement = document.getElementById("wishlist-data");
  if (dataElement) {
    dataElement.textContent = JSON.stringify(updatedWishlist);
  }

  const heartOnPage = document.querySelector(
    `[data-wishlist-heart][data-product-id="${productId}"][data-variant-id="${variantId}"]`
  );
  if (heartOnPage) {
    heartOnPage.classList.add("wishlist-heart--active");
    const heartSvg = heartOnPage.querySelector("svg");
    const heartLabel = heartOnPage.querySelector(".wishlist-heart__label");
    if (heartSvg) heartSvg.setAttribute("fill", "currentColor");
    if (heartLabel) heartLabel.textContent = "Fjern fra ønskeliste";
    heartOnPage.setAttribute("aria-label", "Fjern fra ønskeliste");
  }

  return updatedWishlist;
}

// =========================================================================
// BULK-VALG AF VARER (markerings-firkanter + "fjern/flyt/læg i kurv samlet")
// =========================================================================
// Ingen separat JS-tilstand holdes for markeringerne - selve checkboksenes
// `checked`-tilstand ER kilden til sandhed. Det betyder markeringen
// automatisk nulstilles, hver gang skuffen/kontosiden gentegnes fra bunden
// (fx ved listeskift, åbning af skuffen, eller "Fortryd") - helt uden
// ekstra kode, fordi de nye checkbokse altid starter umarkerede. Skuffen og
// kontosiden holdes bevidst adskilt (samme princip som resten af filen).

function updateWishlistDrawerBulkActionsBar() {
  const bar = document.querySelector("[data-wishlist-bulk-actions]");
  const itemsContainer = document.querySelector("[data-wishlist-items]");
  if (!bar || !itemsContainer) return;

  const checkedCount = itemsContainer.querySelectorAll("[data-wishlist-select]:checked").length;

  if (checkedCount === 0) {
    bar.hidden = true;
    return;
  }

  bar.hidden = false;

  const countLabel = bar.querySelector("[data-wishlist-bulk-count]");
  if (countLabel) {
    countLabel.innerHTML = buildWishlistToastMessageHtml([
      { text: checkedCount, dynamic: true },
      { text: checkedCount === 1 ? " vare valgt" : " varer valgt" },
    ]);
  }

  const moveSelect = bar.querySelector("[data-wishlist-bulk-move-to]");
  if (moveSelect) {
    const wishlistData = getWishlistData();
    const activeListId = getActiveListId(wishlistData);
    const otherLists = wishlistData.lists.filter((list) => list.id !== activeListId);
    const optionsHtml = otherLists.map((list) => `<option value="${list.id}">${list.name}</option>`).join("");
    moveSelect.innerHTML = `<option value="">Flyt til...</option>${optionsHtml}`;
  }
}

function updateWishlistAccountBulkActionsBar() {
  const bar = document.querySelector("[data-wishlist-account-bulk-actions]");
  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  if (!bar || !itemsContainer) return;

  const checkedCount = itemsContainer.querySelectorAll("[data-wishlist-select]:checked").length;

  if (checkedCount === 0) {
    bar.hidden = true;
    return;
  }

  bar.hidden = false;

  const countLabel = bar.querySelector("[data-wishlist-account-bulk-count]");
  if (countLabel) {
    countLabel.innerHTML = buildWishlistToastMessageHtml([
      { text: checkedCount, dynamic: true },
      { text: checkedCount === 1 ? " vare valgt" : " varer valgt" },
    ]);
  }

  const moveSelect = bar.querySelector("[data-wishlist-account-bulk-move-to]");
  if (moveSelect) {
    const wishlistData = getWishlistData();
    const activeListId = getActiveListId(wishlistData);
    const otherLists = wishlistData.lists.filter((list) => list.id !== activeListId);
    const optionsHtml = otherLists.map((list) => `<option value="${list.id}">${list.name}</option>`).join("");
    moveSelect.innerHTML = `<option value="">Flyt til...</option>${optionsHtml}`;
  }
}

// Én delegeret lytter for begge sider - selve opdateringen af den relevante
// handlingslinje afgøres af hvilken container checkboksen sidder i.
document.addEventListener("change", (event) => {
  const checkbox = event.target.closest("[data-wishlist-select]");
  if (!checkbox) return;

  if (checkbox.closest(".wishlist-drawer__item")) {
    updateWishlistDrawerBulkActionsBar();
  } else if (checkbox.closest(".wishlist-account-card")) {
    updateWishlistAccountBulkActionsBar();
  }
});

// --- Skuffen: fjern valgte -----------------------------------------------
document.addEventListener("click", async (event) => {
  const bulkRemoveButton = event.target.closest("[data-wishlist-bulk-remove]");
  if (!bulkRemoveButton) return;

  const itemsContainer = document.querySelector("[data-wishlist-items]");
  if (!itemsContainer) return;

  const checkedBoxes = Array.from(itemsContainer.querySelectorAll("[data-wishlist-select]:checked"));
  if (checkedBoxes.length === 0) return;

  const confirmed = await wishlistConfirm(
    checkedBoxes.length === 1
      ? "Er du sikker på du vil fjerne den valgte vare fra din ønskeliste?"
      : `Er du sikker på du vil fjerne de ${checkedBoxes.length} valgte varer fra din ønskeliste?`
  );
  if (!confirmed) return;

  const listId = getActiveListId(getWishlistData());
  const removedPairs = checkedBoxes.map((checkbox) => ({
    productId: checkbox.dataset.productId,
    variantId: checkbox.dataset.variantId,
  }));

  // Fjern alle markerede varer visuelt med det samme.
  removedPairs.forEach(({ productId, variantId }) => {
    const itemElement = itemsContainer.querySelector(
      `.wishlist-drawer__item[data-product-id="${productId}"][data-variant-id="${variantId}"]`
    );
    if (itemElement) itemElement.remove();
  });

  const emptyState = document.querySelector("[data-wishlist-empty]");
  if (itemsContainer.children.length === 0) {
    itemsContainer.hidden = true;
    if (emptyState) emptyState.hidden = false;
  }

  updateWishlistDrawerBulkActionsBar();

  // Samme "slet med det samme, fortryd gen-tilføjer"-princip som ved fjern
  // af en enkelt vare - ét sekventielt kald pr. vare til samme
  // toggle-endpoint.
  for (const { productId, variantId } of removedPairs) {
    try {
      await removeItemFromWishlistData(productId, variantId, listId);
    } catch (error) {
      console.error("Kunne ikke fjerne vare:", error);
    }
  }

  const count = removedPairs.length;
  showWishlistPopup({
    messageParts: [
      { text: count, dynamic: true },
      { text: count === 1 ? " vare er fjernet fra din ønskeliste." : " varer er fjernet fra din ønskeliste." },
    ],
    actionText: "Fortryd",
    variant: "error",
    onAction: async () => {
      try {
        for (const { productId, variantId } of removedPairs) {
          await readdWishlistItemToWishlistData(productId, variantId, listId);
        }

        const restoredEmptyState = document.querySelector("[data-wishlist-empty]");
        const restoredItemsContainer = document.querySelector("[data-wishlist-items]");
        if (restoredEmptyState && restoredItemsContainer) {
          renderWishlistDrawer(getWishlistData(), restoredEmptyState, restoredItemsContainer);
        }
      } catch (error) {
        console.error("Kunne ikke fortryde fjernelse:", error);
      }
    },
  });
});

// --- Skuffen: flyt valgte til... -----------------------------------------
document.addEventListener("change", async (event) => {
  const bulkMoveSelect = event.target.closest("[data-wishlist-bulk-move-to]");
  if (!bulkMoveSelect) return;

  const toListId = bulkMoveSelect.value;
  if (!toListId) return;

  const itemsContainer = document.querySelector("[data-wishlist-items]");
  if (!itemsContainer) return;

  const checkedBoxes = Array.from(itemsContainer.querySelectorAll("[data-wishlist-select]:checked"));
  bulkMoveSelect.value = "";
  if (checkedBoxes.length === 0) return;

  const fromListId = getActiveListId(getWishlistData());
  const movedPairs = checkedBoxes.map((checkbox) => ({
    productId: checkbox.dataset.productId,
    variantId: checkbox.dataset.variantId,
  }));

  for (const { productId, variantId } of movedPairs) {
    try {
      const response = await fetch("/apps/onskeliste", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "moveItem", productId: productId, variantId: variantId, fromListId: fromListId, toListId: toListId }),
      });
      if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    } catch (error) {
      console.error("Kunne ikke flytte vare:", error);
    }
  }

  try {
    const freshResponse = await fetch("/apps/onskeliste");
    if (!freshResponse.ok) throw new Error(`Serveren svarede ${freshResponse.status}`);
    const freshWishlist = await freshResponse.json();

    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) dataElement.textContent = JSON.stringify(freshWishlist);

    const emptyState = document.querySelector("[data-wishlist-empty]");
    const freshItemsContainer = document.querySelector("[data-wishlist-items]");
    if (emptyState && freshItemsContainer) {
      renderWishlistDrawer(freshWishlist, emptyState, freshItemsContainer);
    }

    syncWishlistHeartState();

    const targetList = freshWishlist.lists.find((list) => list.id === toListId);
    const targetListName = targetList ? targetList.name : "listen";
    const count = movedPairs.length;

    showWishlistPopup({
      messageParts: [
        { text: count, dynamic: true },
        { text: count === 1 ? " vare blev flyttet til " : " varer blev flyttet til " },
        { text: targetListName, dynamic: true },
        { text: "." },
      ],
      variant: "success",
    });
  } catch (error) {
    console.error("Kunne ikke flytte valgte varer:", error);
    showWishlistPopup({
      message: "Der opstod en fejl. Prøv igen.",
      variant: "error",
    });
  }
});

// --- Skuffen: læg valgte i kurv -------------------------------------------
document.addEventListener("click", async (event) => {
  const bulkAddToCartButton = event.target.closest("[data-wishlist-bulk-add-to-cart]");
  if (!bulkAddToCartButton) return;

  const itemsContainer = document.querySelector("[data-wishlist-items]");
  if (!itemsContainer) return;

  const checkedBoxes = Array.from(itemsContainer.querySelectorAll("[data-wishlist-select]:checked"));
  if (checkedBoxes.length === 0) return;

  const cartItems = [];
  const addedPairs = [];

  checkedBoxes.forEach((checkbox) => {
    const itemElement = checkbox.closest(".wishlist-drawer__item");
    // Udsolgte varer har intet "læg i kurv"-ikon i skuffen i forvejen -
    // spring dem over her, i stedet for at forsøge og fejle.
    if (!itemElement || itemElement.classList.contains("wishlist-item--sold-out")) return;

    const quantityInput = itemElement.querySelector("[data-wishlist-qty-input]");
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    cartItems.push({ id: itemElement.dataset.variantId, quantity: quantity });
    addedPairs.push({
      productId: itemElement.dataset.productId,
      variantId: itemElement.dataset.variantId,
    });
  });

  if (cartItems.length === 0) return;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: cartItems }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || "Kunne ikke tilføje til kurv");
    }

    const count = addedPairs.length;
    showWishlistPopup({
      messageParts: [
        { text: count, dynamic: true },
        { text: count === 1 ? " vare tilføjet til kurv." : " varer tilføjet til kurv." },
      ],
      linkHref: "/cart",
      linkText: "Se indkøbskurv",
      linkAriaControls: "cart-drawer",
      variant: "success",
    });

    const sectionId = getCartDrawerSectionId();
    const cartContent = await fetchCartWithSection(sectionId);

    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "line-item:change",
        cart: cartContent,
      },
    }));

    for (const { productId, variantId } of addedPairs) {
      try {
        await removeItemFromWishlistData(productId, variantId);
      } catch (error) {
        console.error("Kunne ikke fjerne vare fra ønskeliste efter tilføjelse til kurv:", error);
      }
    }

    addedPairs.forEach(({ productId, variantId }) => {
      const itemElement = itemsContainer.querySelector(
        `.wishlist-drawer__item[data-product-id="${productId}"][data-variant-id="${variantId}"]`
      );
      if (itemElement) itemElement.remove();
    });

    const emptyState = document.querySelector("[data-wishlist-empty]");
    if (itemsContainer.children.length === 0) {
      itemsContainer.hidden = true;
      if (emptyState) emptyState.hidden = false;
    }

    updateWishlistDrawerBulkActionsBar();
  } catch (error) {
    console.error("Kunne ikke tilføje valgte varer til kurv:", error);
    showWishlistPopup({
      message: "Der opstod en fejl. Prøv igen.",
      variant: "error",
    });
  }
});

// --- Kontosiden: fjern valgte ---------------------------------------------
document.addEventListener("click", async (event) => {
  const bulkRemoveButton = event.target.closest("[data-wishlist-account-bulk-remove]");
  if (!bulkRemoveButton) return;

  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  if (!itemsContainer) return;

  const checkedBoxes = Array.from(itemsContainer.querySelectorAll("[data-wishlist-select]:checked"));
  if (checkedBoxes.length === 0) return;

  const confirmed = await wishlistConfirm(
    checkedBoxes.length === 1
      ? "Er du sikker på du vil fjerne den valgte vare fra din ønskeliste?"
      : `Er du sikker på du vil fjerne de ${checkedBoxes.length} valgte varer fra din ønskeliste?`
  );
  if (!confirmed) return;

  const listId = getActiveListId(getWishlistData());
  const removedPairs = checkedBoxes.map((checkbox) => ({
    productId: checkbox.dataset.productId,
    variantId: checkbox.dataset.variantId,
  }));

  removedPairs.forEach(({ productId, variantId }) => {
    const cardElement = itemsContainer.querySelector(
      `.wishlist-account-card[data-product-id="${productId}"][data-variant-id="${variantId}"]`
    );
    if (cardElement) cardElement.remove();
  });

  const emptyState = document.querySelector("[data-wishlist-account-empty]");
  if (itemsContainer.children.length === 0) {
    itemsContainer.hidden = true;
    if (emptyState) emptyState.hidden = false;
  } else {
    reapplyWishlistAccountRowLimit();
  }

  updateWishlistAccountBulkActionsBar();

  for (const { productId, variantId } of removedPairs) {
    try {
      await removeItemFromWishlistData(productId, variantId, listId);
    } catch (error) {
      console.error("Kunne ikke fjerne vare:", error);
    }
  }

  const count = removedPairs.length;
  showWishlistPopup({
    messageParts: [
      { text: count, dynamic: true },
      { text: count === 1 ? " vare er fjernet fra din ønskeliste." : " varer er fjernet fra din ønskeliste." },
    ],
    actionText: "Fortryd",
    variant: "error",
    onAction: async () => {
      try {
        for (const { productId, variantId } of removedPairs) {
          await readdWishlistItemToWishlistData(productId, variantId, listId);
        }
        await refreshWishlistAccountGrid();
      } catch (error) {
        console.error("Kunne ikke fortryde fjernelse:", error);
      }
    },
  });
});

// --- Kontosiden: flyt valgte til... ---------------------------------------
document.addEventListener("change", async (event) => {
  const bulkMoveSelect = event.target.closest("[data-wishlist-account-bulk-move-to]");
  if (!bulkMoveSelect) return;

  const toListId = bulkMoveSelect.value;
  if (!toListId) return;

  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  if (!itemsContainer) return;

  const checkedBoxes = Array.from(itemsContainer.querySelectorAll("[data-wishlist-select]:checked"));
  bulkMoveSelect.value = "";
  if (checkedBoxes.length === 0) return;

  const fromListId = getActiveListId(getWishlistData());
  const movedPairs = checkedBoxes.map((checkbox) => ({
    productId: checkbox.dataset.productId,
    variantId: checkbox.dataset.variantId,
  }));

  for (const { productId, variantId } of movedPairs) {
    try {
      const response = await fetch("/apps/onskeliste", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "moveItem", productId: productId, variantId: variantId, fromListId: fromListId, toListId: toListId }),
      });
      if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    } catch (error) {
      console.error("Kunne ikke flytte vare:", error);
    }
  }

  try {
    await refreshWishlistAccountGrid();
    syncWishlistHeartState();

    const freshWishlist = getWishlistData();
    const targetList = freshWishlist.lists.find((list) => list.id === toListId);
    const targetListName = targetList ? targetList.name : "listen";
    const count = movedPairs.length;

    showWishlistPopup({
      messageParts: [
        { text: count, dynamic: true },
        { text: count === 1 ? " vare blev flyttet til " : " varer blev flyttet til " },
        { text: targetListName, dynamic: true },
        { text: "." },
      ],
      variant: "success",
    });
  } catch (error) {
    console.error("Kunne ikke flytte valgte varer:", error);
    showWishlistPopup({
      message: "Der opstod en fejl. Prøv igen.",
      variant: "error",
    });
  }
});

// --- Kontosiden: læg valgte i kurv -----------------------------------------
document.addEventListener("click", async (event) => {
  const bulkAddToCartButton = event.target.closest("[data-wishlist-account-bulk-add-to-cart]");
  if (!bulkAddToCartButton) return;

  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  if (!itemsContainer) return;

  const checkedBoxes = Array.from(itemsContainer.querySelectorAll("[data-wishlist-select]:checked"));
  if (checkedBoxes.length === 0) return;

  const cartItems = [];
  const addedPairs = [];

  checkedBoxes.forEach((checkbox) => {
    const cardElement = checkbox.closest(".wishlist-account-card");
    // Udsolgte varer har intet "læg i kurv"-ikon på kontosiden i forvejen -
    // spring dem over her, i stedet for at forsøge og fejle. Kontosidens
    // kort har (i modsætning til skuffen) ikke sit eget antal-felt, så der
    // lægges altid 1 stk. i kurven pr. valgt vare - samme som den
    // eksisterende enkelt-vare "læg i kurv"-knap på kontosiden.
    if (!cardElement || cardElement.classList.contains("wishlist-item--sold-out")) return;

    cartItems.push({ id: cardElement.dataset.variantId, quantity: 1 });
    addedPairs.push({
      productId: cardElement.dataset.productId,
      variantId: cardElement.dataset.variantId,
    });
  });

  if (cartItems.length === 0) return;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: cartItems }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || "Kunne ikke tilføje til kurv");
    }

    const count = addedPairs.length;
    showWishlistPopup({
      messageParts: [
        { text: count, dynamic: true },
        { text: count === 1 ? " vare tilføjet til kurv." : " varer tilføjet til kurv." },
      ],
      linkHref: "/cart",
      linkText: "Se indkøbskurv",
      linkAriaControls: "cart-drawer",
      variant: "success",
    });

    const sectionId = getCartDrawerSectionId();
    const cartContent = await fetchCartWithSection(sectionId);

    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "line-item:change",
        cart: cartContent,
      },
    }));

    for (const { productId, variantId } of addedPairs) {
      try {
        await removeItemFromWishlistData(productId, variantId);
      } catch (error) {
        console.error("Kunne ikke fjerne vare fra ønskeliste efter tilføjelse til kurv:", error);
      }
    }

    addedPairs.forEach(({ productId, variantId }) => {
      const cardElement = itemsContainer.querySelector(
        `.wishlist-account-card[data-product-id="${productId}"][data-variant-id="${variantId}"]`
      );
      if (cardElement) cardElement.remove();
    });

    const emptyState = document.querySelector("[data-wishlist-account-empty]");
    if (itemsContainer.children.length === 0) {
      itemsContainer.hidden = true;
      if (emptyState) emptyState.hidden = false;
    } else {
      reapplyWishlistAccountRowLimit();
    }

    updateWishlistAccountBulkActionsBar();
  } catch (error) {
    console.error("Kunne ikke tilføje valgte varer til kurv:", error);
    showWishlistPopup({
      message: "Der opstod en fejl. Prøv igen.",
      variant: "error",
    });
  }
});

document.addEventListener("click", async (event) => {
  const moveButton = event.target.closest("[data-move-to-wishlist]");
  if (!moveButton) return;

  const productId = moveButton.dataset.productId;
  const variantId = moveButton.dataset.variantId;
  const lineKey = moveButton.dataset.lineKey;
  const title = moveButton.dataset.title;
  const quantity = parseInt(moveButton.dataset.quantity, 10) || 1;

  // Samme login-tjek som hjertet: ikke logget ind kan ikke flytte varen til
  // en ønskeliste, så vi viser samme pop-up her.
  if (!document.getElementById("wishlist-data")) {
    showWishlistLoginPrompt(productId, variantId);
    return;
  }

  try {
    const wishlistResponse = await fetch("/apps/onskeliste");
    if (!wishlistResponse.ok) throw new Error(`Serveren svarede ${wishlistResponse.status}`);
    const wishlist = await wishlistResponse.json();
    const activeListId = getActiveListId(wishlist);
    const alreadyOnWishlist = isInWishlist(wishlist, productId, variantId, activeListId);

    if (alreadyOnWishlist) {
      showWishlistPopup({
        messageParts: [
          { text: title, dynamic: true },
          { text: " er allerede på din ønskeliste." },
        ],
        variant: "error",
      });
      return;
    }

    const changeResponse = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });

     if (!changeResponse.ok) throw new Error(`Serveren svarede ${changeResponse.status}`);
    const cartContent = await changeResponse.json();

      const heartOnPage = document.querySelector(
      `[data-wishlist-heart][data-product-id="${productId}"][data-variant-id="${variantId}"]`
    );
    if (heartOnPage) {
      heartOnPage.classList.add("wishlist-heart--active");
      const heartSvg = heartOnPage.querySelector("svg");
      const heartLabel = heartOnPage.querySelector(".wishlist-heart__label");
      if (heartSvg) heartSvg.setAttribute("fill", "currentColor");
      if (heartLabel) heartLabel.textContent = "Fjern fra ønskeliste";
      heartOnPage.setAttribute("aria-label", "Fjern fra ønskeliste");
    }

    showWishlistPopup({
      messageParts: [
        { text: title, dynamic: true },
        { text: " er flyttet til din ønskeliste." },
      ],
      linkHref: "#wishlist-drawer",
      linkText: "Se ønskeliste",
      linkAriaControls: "wishlist-drawer",
      variant: "success",
    });

    const sectionId = getCartDrawerSectionId();
    const sectionHtml = await fetchCartDrawerSectionHtml(sectionId);
    cartContent.sections = cartContent.sections || {};
    if (sectionId && sectionHtml) {
      cartContent.sections[sectionId] = sectionHtml;
    }

    // Send samme event som temaets egen kode, så <cart-drawer> selv
    // opdaterer sit indhold ud fra cartContent.sections[sectionId] (se
    // cart-drawer.js -> onCartChange_fn/replaceContent_fn). Kurv-skuffen
    // er registreret i en section group (overlay-group.json), så dens
    // wrapper-id starter med "sections--", ikke "shopify-section-" - det
    // var derfor getCartDrawerWrapper() ikke kunne finde den før.
    // baseEvent er IKKE "variant:add", så temaets indbyggede auto-åbn-logik
    // ikke trigges - vi styrer stadig selv hvornår skuffen skal åbnes (lige
    // nedenfor), uafhængigt af butikkens cartType-indstilling.
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "line-item:change",
        cart: cartContent,
      },
    }));
    // Åbn kurv-skuffen, HVIS den ikke allerede er åben - indholdet er nu
    // allerede opdateret ovenfor via det almindelige cart:change-event.
    const cartDrawerElement = document.querySelector("cart-drawer");
    if (cartDrawerElement && !cartDrawerElement.hasAttribute("open")) {
      cartDrawerElement.setAttribute("open", "");
    }

    const addResponse = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: productId, variantId: variantId, listId: activeListId }),
    });

    if (!addResponse.ok) throw new Error(`Serveren svarede ${addResponse.status}`);

    if (quantity > 1) {
      await fetch("/apps/onskeliste", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "setQuantity",
          productId: productId,
          variantId: variantId,
          quantity: quantity,
        }),
      });
    }

    const freshWishlistResponse = await fetch("/apps/onskeliste");
    const freshWishlist = await freshWishlistResponse.json();

    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) {
      dataElement.textContent = JSON.stringify(freshWishlist);
    }

    const wishlistEmptyState = document.querySelector("[data-wishlist-empty]");
    const wishlistItemsContainer = document.querySelector("[data-wishlist-items]");
    if (wishlistEmptyState && wishlistItemsContainer) {
      renderWishlistDrawer(freshWishlist, wishlistEmptyState, wishlistItemsContainer);
    }

    // Hvis kontosidens ønskeliste-gitter også findes på siden (fx hvis man
    // åbner kurv-skuffen, mens man står på "Din konto", og flytter en vare
    // til ønskelisten derfra), skal det gitter også opdateres - ellers ser
    // man ikke den nye vare der, før man selv genindlæser siden.
    const accountItemsContainer = document.querySelector("[data-wishlist-account-items]");
    const accountEmptyState = document.querySelector("[data-wishlist-account-empty]");
    if (accountEmptyState && accountItemsContainer) {
      renderWishlistAccountGrid(freshWishlist, accountEmptyState, accountItemsContainer);
    }

  } catch (error) {
    console.error("Kunne ikke flytte vare til ønskeliste:", error);
    showWishlistPopup({
      message: "Der opstod en fejl. Prøv igen.",
      variant: "error",
    });
  }
});

document.addEventListener("click", async (event) => {
  const trigger = event.target.closest("#openWishlistDrawer");
  if (!trigger) return;

  // Ikke logget ind: vis login-pop-up'en i stedet for at åbne den (tomme)
  // ønskeliste-skuffe - samme signal (fravær af #wishlist-data-øen) som
  // resten af filen bruger. preventDefault, fordi ikonet ellers selv
  // navigerer til #wishlist-drawer og åbner skuffen uden om denne kode.
  if (!document.getElementById("wishlist-data")) {
    event.preventDefault();
    showWishlistLoginPrompt();
    return;
  }

  const emptyState = document.querySelector("[data-wishlist-empty]");
  const itemsContainer = document.querySelector("[data-wishlist-items]");
  if (!emptyState || !itemsContainer) return;

  try {
    const response = await fetch("/apps/onskeliste");
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    const wishlist = await response.json();
    renderWishlistDrawer(wishlist, emptyState, itemsContainer);
  } catch (error) {
    console.error("Kunne ikke hente ønskeliste:", error);
  }
});
// Træk-for-at-lukke er droppet efter flere forsøg (2026-09-10) - skuffen
// lukkes i stedet kun via kryds-knappen og klik udenfor, som begge er
// indbygget i <x-drawer> og virker pålideligt.

document.addEventListener("change", async (event) => {
  const select = event.target.closest("[data-wishlist-list-select]");
  if (!select) return;

  setActiveListId(select.value);

  try {
    const response = await fetch("/apps/onskeliste");
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    const wishlist = await response.json();

    const emptyState = document.querySelector("[data-wishlist-empty]");
    const itemsContainer = document.querySelector("[data-wishlist-items]");
    if (emptyState && itemsContainer) {
      renderWishlistDrawer(wishlist, emptyState, itemsContainer);
    }

    syncWishlistHeartState();
  } catch (error) {
    console.error("Kunne ikke skifte liste:", error);
  }
});

document.addEventListener("click", async (event) => {
  const createButton = event.target.closest("[data-wishlist-create-list]");
  if (!createButton) return;

  const name = await wishlistPrompt("Navn på den nye liste:");
  if (name === null) return;

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "createList", name: name }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    const updatedWishlist = await response.json();
    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) {
      dataElement.textContent = JSON.stringify(updatedWishlist);
    }

    const newList = updatedWishlist.lists[updatedWishlist.lists.length - 1];
    if (newList) {
      setActiveListId(newList.id);
    }

        const emptyState = document.querySelector("[data-wishlist-empty]");
    const itemsContainer = document.querySelector("[data-wishlist-items]");
    if (emptyState && itemsContainer) {
      renderWishlistDrawer(updatedWishlist, emptyState, itemsContainer);
    }

    syncWishlistHeartState();
  } catch (error) {
    console.error("Kunne ikke flytte vare:", error);
  }
});

document.addEventListener("click", async (event) => {
  const renameListButton = event.target.closest("[data-wishlist-rename-list]");
  if (!renameListButton) return;

  const wishlistData = getWishlistData();
  const activeListId = getActiveListId(wishlistData);
  const activeList = wishlistData.lists.find((list) => list.id === activeListId);
  if (!activeList) return;

  const newName = await wishlistPrompt("Nyt navn på listen:", activeList.name);
  if (newName === null) return;

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "renameList", listId: activeListId, name: newName }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    const freshResponse = await fetch("/apps/onskeliste");
    if (!freshResponse.ok) throw new Error(`Serveren svarede ${freshResponse.status}`);
    const freshWishlist = await freshResponse.json();

    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) {
      dataElement.textContent = JSON.stringify(freshWishlist);
    }

    const renameEmptyState = document.querySelector("[data-wishlist-empty]");
    const renameItemsContainer = document.querySelector("[data-wishlist-items]");
    if (renameEmptyState && renameItemsContainer) {
      renderWishlistDrawer(freshWishlist, renameEmptyState, renameItemsContainer);
    }
  } catch (error) {
    console.error("Kunne ikke omdøbe liste:", error);
  }
});

document.addEventListener("click", async (event) => {
  const deleteListButton = event.target.closest("[data-wishlist-delete-list]");
  if (!deleteListButton) return;

  const confirmed = await wishlistConfirm("Er du sikker på du vil slette denne ønskeliste?");
  if (!confirmed) return;

  try {
    const response = await fetch("/apps/onskeliste");
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    const freshWishlist = await response.json();

    const activeListId = getActiveListId(freshWishlist);
    const activeList = freshWishlist.lists.find((list) => list.id === activeListId);
    if (!activeList) return;

    const remainingLists = freshWishlist.lists.filter((list) => list.id !== activeListId);
    const fallbackListId = remainingLists.length > 0 ? remainingLists[0].id : null;
    if (fallbackListId) setActiveListId(fallbackListId);

    const deleteEmptyState = document.querySelector("[data-wishlist-empty]");
    const deleteItemsContainer = document.querySelector("[data-wishlist-items]");
    if (deleteEmptyState && deleteItemsContainer) {
      renderWishlistDrawer({ lists: remainingLists }, deleteEmptyState, deleteItemsContainer);
    }

    showWishlistPopup({
      messageParts: [
        { text: activeList.name, dynamic: true },
        { text: " er slettet." },
      ],
      actionText: "Fortryd",
      variant: "error",
      onAction: async () => {
        setActiveListId(activeListId);
        try {
          const restoredResponse = await fetch("/apps/onskeliste");
          if (!restoredResponse.ok) throw new Error(`Serveren svarede ${restoredResponse.status}`);
          const restoredWishlist = await restoredResponse.json();

          const dataElement = document.getElementById("wishlist-data");
          if (dataElement) {
            dataElement.textContent = JSON.stringify(restoredWishlist);
          }

          const restoredEmptyState = document.querySelector("[data-wishlist-empty]");
          const restoredItemsContainer = document.querySelector("[data-wishlist-items]");
          if (restoredEmptyState && restoredItemsContainer) {
            renderWishlistDrawer(restoredWishlist, restoredEmptyState, restoredItemsContainer);
          }
        } catch (error) {
          console.error("Kunne ikke fortryde sletning:", error);
        }
      },
      onTimeout: async () => {
        try {
          const deleteResponse = await fetch("/apps/onskeliste", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action: "deleteList", listId: activeListId }),
          });

          if (!deleteResponse.ok) {
            const errorText = await deleteResponse.text();
            throw new Error(`Serveren svarede ${deleteResponse.status}: ${errorText}`);
          }

          const updatedWishlist = await deleteResponse.json();
          const dataElement = document.getElementById("wishlist-data");
          if (dataElement) {
            dataElement.textContent = JSON.stringify(updatedWishlist);
          }
        } catch (error) {
          console.error("Kunne ikke slette liste:", error);
        }
      },
    });
  } catch (error) {
    console.error("Kunne ikke slette liste:", error);
  }
});

document.addEventListener("change", async (event) => {
  const moveSelect = event.target.closest("[data-wishlist-move-to]");
  if (!moveSelect) return;

  const toListId = moveSelect.value;
  if (!toListId) return;

  const productId = moveSelect.dataset.productId;
  const variantId = moveSelect.dataset.variantId;
  const fromListId = getActiveListId(getWishlistData());
  const itemElement = moveSelect.closest(".wishlist-drawer__item");
  const title = getWishlistItemDisplayTitle(itemElement, ".wishlist-drawer__item-title");

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "moveItem", productId: productId, variantId: variantId, fromListId: fromListId, toListId: toListId }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    const freshResponse = await fetch("/apps/onskeliste");
    if (!freshResponse.ok) throw new Error(`Serveren svarede ${freshResponse.status}`);
    const freshWishlist = await freshResponse.json();

    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) {
      dataElement.textContent = JSON.stringify(freshWishlist);
    }

    syncWishlistHeartState();

    const targetList = freshWishlist.lists.find((list) => list.id === toListId);
    const targetListName = targetList ? targetList.name : "listen";

    // Erstat kun selve vare-linjen med en bekræftelsestekst (samme mønster
    // som "tilføjet til kurv"), i stedet for at genrendere hele skuffen med
    // det samme - så resten af listen ikke hopper rundt, og "Fortryd" kan nå
    // at fortryde flytningen, mens teksten stadig er synlig.
    if (itemElement) {
      itemElement.classList.add("wishlist-drawer__item--added");
      itemElement.innerHTML = `
        <p class="wishlist-drawer__item-added-text">
          <span class="wishlist-toast__value">${title}</span><span class="wishlist-toast__label"> blev flyttet til </span><span class="wishlist-toast__value">${targetListName}</span><span class="wishlist-toast__label">.</span>
          <button type="button" class="link wishlist-drawer__item-undo">Fortryd</button>
        </p>
      `;

      const undoButton = itemElement.querySelector(".wishlist-drawer__item-undo");
      if (undoButton) {
        undoButton.addEventListener("click", async () => {
          try {
            const undoResponse = await fetch("/apps/onskeliste", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ action: "moveItem", productId: productId, variantId: variantId, fromListId: toListId, toListId: fromListId }),
            });

            if (!undoResponse.ok) {
              const errorText = await undoResponse.text();
              throw new Error(`Serveren svarede ${undoResponse.status}: ${errorText}`);
            }

            // VIGTIGT: brug ikke POST-svaret direkte - det er ikke beriget
            // med titel/billede/pris, kun selve wishlist-strukturen, hvilket
            // giver "undefined"-tekster hvis det bruges til genrendering.
            // Hent altid et frisk, beriget GET-kald bagefter.
            const freshResponse = await fetch("/apps/onskeliste");
            if (!freshResponse.ok) throw new Error(`Serveren svarede ${freshResponse.status}`);
            const restoredWishlist = await freshResponse.json();

            const restoredDataElement = document.getElementById("wishlist-data");
            if (restoredDataElement) {
              restoredDataElement.textContent = JSON.stringify(restoredWishlist);
            }

            const restoredEmptyState = document.querySelector("[data-wishlist-empty]");
            const restoredItemsContainer = document.querySelector("[data-wishlist-items]");
            if (restoredEmptyState && restoredItemsContainer) {
              renderWishlistDrawer(restoredWishlist, restoredEmptyState, restoredItemsContainer);
            }

            syncWishlistHeartState();
          } catch (error) {
            console.error("Kunne ikke fortryde flytning:", error);
          }
        });
      }
    }
  } catch (error) {
    console.error("Kunne ikke flytte vare:", error);
  }
});

// =========================================================================
// Ønskeliste-side på "Din konto" (fuld side med billeder i gittervisning,
// i modsætning til den kompakte skuffe). Bruger de SAMME data (samme
// /apps/onskeliste-endpoint og samme #wishlist-data-ø), men helt sin egen
// markup og sine egne data-attributter (data-wishlist-account-*) - bevidst
// IKKE de samme som skuffen (data-wishlist-items/data-wishlist-remove/osv.),
// fordi skuffens kode overalt bruger document.querySelector (som kun finder
// ÉT element). Hvis kontosiden genbrugte samme attributter, ville skuffens
// og kontosidens opdateringer let komme til at ramme forkert container. Ved
// at holde dem adskilt kan denne nye funktionalitet tilføjes uden at røre
// eller risikere at ødelægge skuffens eksisterende, testede kode.
// =========================================================================

function renderWishlistAccountGrid(wishlist, emptyState, itemsContainer) {
  // Se tilsvarende kommentar i renderWishlistDrawer - enhver fuld
  // gentegning skal altid skjule bulk-handlingslinjen igen, da de nye
  // checkbokse renderes umarkerede.
  const accountBulkActionsBar = document.querySelector("[data-wishlist-account-bulk-actions]");
  if (accountBulkActionsBar) accountBulkActionsBar.hidden = true;

const listSelect = document.querySelector("[data-wishlist-account-list-select]");
  const renameButton = document.querySelector("[data-wishlist-account-rename-list]");
  const deleteButton = document.querySelector("[data-wishlist-account-delete-list]");
  const shareButton = document.querySelector("[data-wishlist-account-share-pdf]");
  const activeListId = getActiveListId(wishlist);
  const hasLists = wishlist.lists.length > 0;

  if (listSelect) {
    listSelect.hidden = !hasLists;
    const listOptionsHtml = wishlist.lists
      .map((list) => `<option value="${list.id}"${list.id === activeListId ? " selected" : ""}>${list.name}</option>`)
      .join("");
    listSelect.innerHTML = `${listOptionsHtml}<option value="__create_list__">+ Opret ny liste</option>`;
  }
  if (renameButton) renameButton.hidden = !hasLists;
  if (deleteButton) deleteButton.hidden = !hasLists;
  if (shareButton) shareButton.hidden = !hasLists;

  const activeList = wishlist.lists.find((list) => list.id === activeListId);
  const items = activeList ? activeList.items : [];

  if (items.length === 0) {
    emptyState.hidden = false;
    itemsContainer.hidden = true;
    itemsContainer.innerHTML = "";

    // Teksten skal afspejle om kunden reelt har nogen lister eller ej -
    // "du har ingen ønskelister" giver ikke mening, hvis kunden faktisk har
    // en (bare tom) liste, og omvendt.
    const emptyText = document.querySelector("[data-wishlist-account-empty-text]");
    if (emptyText) {
      emptyText.textContent = hasLists
        ? "Du har endnu ikke tilføjet varer til din ønskeliste."
        : "Du har ingen ønskelister.";
    }

    // Kun vis "Opret din første ønskeliste"-knappen, når kunden reelt ikke
    // har NOGEN lister endnu - har kunden allerede en (bare tom) liste,
    // fungerer "+ Opret ny liste" i dropdownen fint (se forklaring ved
    // create_list_sentinel-tjekket i change-lytteren nedenfor).
    const createFirstListButton = document.querySelector("[data-wishlist-account-create-first-list]");
    if (createFirstListButton) {
      createFirstListButton.hidden = hasLists;
    }

    // Tom liste: sørg for at "Vis flere"-knappen fra den forrige liste
    // bliver skjult (se reapplyWishlistAccountRowLimit).
    reapplyWishlistAccountRowLimit();
    return;
  }

  emptyState.hidden = true;
  itemsContainer.hidden = false;

  const cartIconTemplate = document.getElementById("wishlist-cart-icon-template");
  const cartIconHtml = cartIconTemplate ? cartIconTemplate.innerHTML : "";

  const otherLists = wishlist.lists.filter((list) => list.id !== activeListId);
  const moveToOptionsHtml = otherLists.map((list) => `<option value="${list.id}">${list.name}</option>`).join("");

  itemsContainer.innerHTML = items
    .map(
      (item) => `
        <div class="wishlist-account-card${item.available === false ? " wishlist-item--sold-out" : ""}" data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" data-title="${item.title}">
          <div class="wishlist-account-card__image-wrap">
            <a href="${item.url}" class="wishlist-account-card__image-link">
              <img src="${item.image}" alt="${item.title}" width="300" height="300" class="wishlist-account-card__image" loading="lazy">
            </a>
            <input type="checkbox" class="wishlist-select-checkbox" data-wishlist-select data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Vælg ${item.title}">
            ${item.available === false ? `<div class="wishlist-sold-out-overlay"></div>
            <svg class="wishlist-sold-out-line" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" focusable="false">
              <line x1="0" y1="0" x2="100" y2="100" vector-effect="non-scaling-stroke"></line>
            </svg>` : `<button type="button" class="wishlist-add-to-cart wishlist-account-card__cart-button" data-wishlist-account-add-to-cart aria-label="Tilføj til kurv">
              ${cartIconHtml}
              <span class="wishlist-add-to-cart__badge">+</span>
            </button>`}
          </div>
          <div class="wishlist-account-card__info">
            <a href="${item.url}" class="wishlist-account-card__title">${item.title}</a>
            ${item.variant_title && item.variant_title !== "Default Title" ? `<p class="smallcaps text-subdued">${item.variant_title}</p>` : ""}
            <p>${item.price} kr.</p>
          </div>
          <div class="wishlist-account-card__actions">
            <div class="wishlist-account-card__secondary-actions">
              ${otherLists.length > 0 ? `
              <select class="wishlist-account-card__move-select" data-wishlist-account-move-to data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Flyt til anden ønskeliste">
                <option value="">Flyt til...</option>
                ${moveToOptionsHtml}
              </select>` : ""}
              <button type="button" class="hover:animate-icon-block" data-wishlist-account-remove data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" aria-label="Fjern fra ønskeliste">
                <svg aria-hidden="true" focusable="false" fill="none" class="icon" viewBox="0 0 16 16" style="width: 16px; height: 16px;">
                  <path d="M2 4h12M6 4V2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V4m2 0-.6 9.4a1 1 0 0 1-1 .9H4.6a1 1 0 0 1-1-.9L3 4M6.5 7v4M9.5 7v4" stroke="#a3a3a3" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      `
    )
    .join("");

  // "Vis flere" skal dække PRÆCIS én ekstra række - og en række er kun 4
  // varer bred på desktop (1x4-gitteret), mens den kun er 1 vare bred på
  // mobil (én kolonne). Derfor beregnes grænsen ud fra den aktuelle
  // skærmbredde i stedet for et fast tal, og genberegnes ved resize (se
  // reapplyWishlistAccountRowLimit herunder).
  wishlistAccountExpanded = false;
  reapplyWishlistAccountRowLimit();
}

function getWishlistAccountRowSize() {
  // Desktop: 4 kolonner x 1 række = 4. Mobil: 2 kolonner x 2 rækker = 4.
  const isDesktop = window.matchMedia("(min-width: 750px)").matches;
  const columns = isDesktop ? 4 : 2;
  const rows = isDesktop ? 1 : 2;
  return columns * rows;
}

let wishlistAccountExpanded = false;

function reapplyWishlistAccountRowLimit() {
  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  const showMoreButton = document.querySelector("[data-wishlist-account-show-more]");
  if (!itemsContainer || !showMoreButton) return;

  const cardElements = Array.from(itemsContainer.querySelectorAll(".wishlist-account-card"));
  // Ingen varer på listen (fx en tom liste): skjul "Vis flere"-knappen helt,
  // så knappen fra en tidligere vist liste ikke bliver hængende.
  if (cardElements.length === 0) {
    showMoreButton.hidden = true;
    return;
  }

  const visibleLimit = getWishlistAccountRowSize();

  // Er der slet ikke flere end én række, er der intet at folde ud/ind - skjul
  // knappen helt, uanset ekspanderet-tilstand.
  if (cardElements.length <= visibleLimit) {
    cardElements.forEach((card) => {
      card.hidden = false;
    });
    showMoreButton.hidden = true;
    return;
  }

  // Selve pil-ikonet ligger fast i Liquid-markuppen (roteres via CSS-klassen
  // "is-expanded") - her opdaterer vi kun tekst-spannet og selve klassen,
  // så ikonet ikke skal genopbygges hver gang.
  const label = showMoreButton.querySelector("[data-wishlist-account-show-more-label]");

  if (wishlistAccountExpanded) {
    cardElements.forEach((card) => {
      card.hidden = false;
    });
    showMoreButton.hidden = false;
    showMoreButton.classList.add("is-expanded");
    if (label) label.textContent = "Vis færre";
  } else {
    cardElements.forEach((card, index) => {
      card.hidden = index >= visibleLimit;
    });
    showMoreButton.hidden = false;
    showMoreButton.classList.remove("is-expanded");
    if (label) label.textContent = `Vis flere (${cardElements.length - visibleLimit})`;
  }
}

document.addEventListener("click", (event) => {
  const showMoreButton = event.target.closest("[data-wishlist-account-show-more]");
  if (!showMoreButton) return;

  // Samme knap skifter mellem "Vis flere" og "Vis færre" ved hvert klik,
  // i stedet for kun at kunne folde ud én gang.
  wishlistAccountExpanded = !wishlistAccountExpanded;
  reapplyWishlistAccountRowLimit();
});

let wishlistAccountResizeTimeout = null;
window.addEventListener("resize", () => {
  clearTimeout(wishlistAccountResizeTimeout);
  wishlistAccountResizeTimeout = setTimeout(reapplyWishlistAccountRowLimit, 150);
});

// Init ved sideindlæsning. VIGTIGT: bruger IKKE #wishlist-data-øen direkte
// (den er kun til den rå "er varen på listen"-tilstand, fx til hjertet) -
// den indeholder ikke nødvendigvis beriget titel/billede/pris. Kun et
// GET-kald til /apps/onskeliste er garanteret beriget (se Worker'ens
// enrichWishlist), så vi henter frisk data her ligesom skuffens
// åbne-handler gør - ellers vises "undefined" for titel/pris.
function initWishlistAccountGrid() {
  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  const emptyState = document.querySelector("[data-wishlist-account-empty]");
  if (!itemsContainer || !emptyState) return;

  refreshWishlistAccountGrid();
}
initWishlistAccountGrid();

async function refreshWishlistAccountGrid() {
  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  const emptyState = document.querySelector("[data-wishlist-account-empty]");
  if (!itemsContainer || !emptyState) return;

  try {
    const response = await fetch("/apps/onskeliste");
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    const wishlist = await response.json();

    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) dataElement.textContent = JSON.stringify(wishlist);

    renderWishlistAccountGrid(wishlist, emptyState, itemsContainer);
  } catch (error) {
    console.error("Kunne ikke opdatere ønskeliste-siden:", error);
  }
}

// Fælles "opret ny liste"-logik for kontosiden, brugt både fra dropdownens
// "+ Opret ny liste"-valgmulighed OG fra den dedikerede knap i tom-tilstand
// (data-wishlist-account-create-first-list). Sidstnævnte er nødvendig, fordi
// en <select> med KUN denne ene valgmulighed (når kunden slet ingen lister
// har) allerede har den valgt som standard - vælger man den "igen", skifter
// værdien ikke, og browseren affyrer derfor slet ikke noget change-event, så
// dropdown-varianten virker først, når kunden i forvejen har mindst én liste.
async function createWishlistAccountList() {
  const name = await wishlistPrompt("Navn på den nye liste:");
  if (name === null) return;

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "createList", name: name }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    const updatedWishlist = await response.json();
    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) dataElement.textContent = JSON.stringify(updatedWishlist);

    const newList = updatedWishlist.lists[updatedWishlist.lists.length - 1];
    if (newList) setActiveListId(newList.id);

    await refreshWishlistAccountGrid();
    syncWishlistHeartState();
  } catch (error) {
    console.error("Kunne ikke oprette liste:", error);
  }
}

document.addEventListener("click", async (event) => {
  const createFirstListButton = event.target.closest("[data-wishlist-account-create-first-list]");
  if (!createFirstListButton) return;

  await createWishlistAccountList();
});

// "Opret ny liste" er nu en fast valgmulighed nederst i selve dropdown-
// menuen (i stedet for sin egen knap) - vælges den, åbnes opret-dialogen,
// og dropdownen nulstilles bagefter til den faktiske aktive liste.
document.addEventListener("change", async (event) => {
  const select = event.target.closest("[data-wishlist-account-list-select]");
  if (!select) return;

  if (select.value === "__create_list__") {
    const currentWishlist = getWishlistData();
    const currentActiveListId = getActiveListId(currentWishlist);
    select.value = currentActiveListId;

    await createWishlistAccountList();
    return;
  }

  setActiveListId(select.value);
  await refreshWishlistAccountGrid();
  syncWishlistHeartState();
});

document.addEventListener("click", async (event) => {
  const removeButton = event.target.closest("[data-wishlist-account-remove]");
  if (!removeButton) return;

  const cardElement = removeButton.closest(".wishlist-account-card");
  const productId = removeButton.dataset.productId;
  const variantId = removeButton.dataset.variantId;
  const title = getWishlistItemDisplayTitle(cardElement, ".wishlist-account-card__title");
  const listId = getActiveListId(getWishlistData());

  const confirmed = await wishlistConfirm(`Er du sikker på du vil fjerne "${title}" fra din ønskeliste?`);
  if (!confirmed) return;

  if (cardElement) cardElement.remove();

  const itemsContainer = document.querySelector("[data-wishlist-account-items]");
  const emptyState = document.querySelector("[data-wishlist-account-empty]");
  if (itemsContainer && itemsContainer.children.length === 0) {
    itemsContainer.hidden = true;
    if (emptyState) emptyState.hidden = false;
  }

  // Selve sletningen sker på serveren MED DET SAMME - se den tilsvarende
  // forklaring ved skuffens fjern-vare-håndtering ovenfor.
  try {
    await removeItemFromWishlistData(productId, variantId, listId);
  } catch (error) {
    console.error("Kunne ikke fjerne vare:", error);
  }

  showWishlistPopup({
    messageParts: [
      { text: title, dynamic: true },
      { text: " er fjernet fra din ønskeliste." },
    ],
    actionText: "Fortryd",
    variant: "error",
    onAction: async () => {
      try {
        await readdWishlistItemToWishlistData(productId, variantId, listId);
        await refreshWishlistAccountGrid();
      } catch (error) {
        console.error("Kunne ikke fortryde fjernelse:", error);
      }
    },
  });
});

document.addEventListener("change", async (event) => {
  const moveSelect = event.target.closest("[data-wishlist-account-move-to]");
  if (!moveSelect) return;

  const toListId = moveSelect.value;
  if (!toListId) return;

  const productId = moveSelect.dataset.productId;
  const variantId = moveSelect.dataset.variantId;
  const fromListId = getActiveListId(getWishlistData());
  const cardElement = moveSelect.closest(".wishlist-account-card");
  const title = getWishlistItemDisplayTitle(cardElement, ".wishlist-account-card__title");

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "moveItem", productId, variantId, fromListId, toListId }),
    });
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);

    const freshResponse = await fetch("/apps/onskeliste");
    if (!freshResponse.ok) throw new Error(`Serveren svarede ${freshResponse.status}`);
    const freshWishlist = await freshResponse.json();
    const dataElement = document.getElementById("wishlist-data");
    if (dataElement) dataElement.textContent = JSON.stringify(freshWishlist);

    syncWishlistHeartState();

    if (cardElement) cardElement.remove();

    const itemsContainer = document.querySelector("[data-wishlist-account-items]");
    const emptyState = document.querySelector("[data-wishlist-account-empty]");
    if (itemsContainer && itemsContainer.children.length === 0) {
      itemsContainer.hidden = true;
      if (emptyState) emptyState.hidden = false;
    }

    const targetList = freshWishlist.lists.find((list) => list.id === toListId);
    const targetListName = targetList ? targetList.name : "listen";

    showWishlistPopup({
      messageParts: [
        { text: title, dynamic: true },
        { text: " blev flyttet til " },
        { text: targetListName, dynamic: true },
        { text: "." },
      ],
      actionText: "Fortryd",
      variant: "success",
      onAction: async () => {
        try {
          const undoResponse = await fetch("/apps/onskeliste", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action: "moveItem", productId, variantId, fromListId: toListId, toListId: fromListId }),
          });
          if (!undoResponse.ok) throw new Error(`Serveren svarede ${undoResponse.status}`);

          await refreshWishlistAccountGrid();
        } catch (error) {
          console.error("Kunne ikke fortryde flytning:", error);
        }
      },
    });
  } catch (error) {
    console.error("Kunne ikke flytte vare:", error);
  }
});

document.addEventListener("click", async (event) => {
  const addButton = event.target.closest("[data-wishlist-account-add-to-cart]");
  if (!addButton) return;

  const cardElement = addButton.closest(".wishlist-account-card");
  if (!cardElement) return;

  const productId = cardElement.dataset.productId;
  const variantId = cardElement.dataset.variantId;
  const title = getWishlistItemDisplayTitle(cardElement, ".wishlist-account-card__title");

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || "Kunne ikke tilføje til kurv");
    }

    showWishlistPopup({
      messageParts: [
        { text: title, dynamic: true },
        { text: " tilføjet til kurv." },
      ],
      linkHref: "/cart",
      linkText: "Se indkøbskurv",
      linkAriaControls: "cart-drawer",
      variant: "success",
    });

    const sectionId = getCartDrawerSectionId();
    const cartContent = await fetchCartWithSection(sectionId);

    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "line-item:change",
        cart: cartContent,
      },
    }));

    // Ligesom i skuffen: når varen er lagt i kurv, fjernes den også fra
    // ønskelisten - ellers ville den blive stående, som om intet var sket.
    await removeItemFromWishlistData(productId, variantId);

    cardElement.remove();

    const itemsContainer = document.querySelector("[data-wishlist-account-items]");
    const emptyState = document.querySelector("[data-wishlist-account-empty]");
    if (itemsContainer && itemsContainer.children.length === 0) {
      itemsContainer.hidden = true;
      if (emptyState) emptyState.hidden = false;
    } else {
      // Genberegn "Vis flere"-optællingen, da der nu er én vare mindre.
      reapplyWishlistAccountRowLimit();
    }
  } catch (error) {
    console.error("Kunne ikke tilføje til kurv:", error);
    showWishlistPopup({
      message: "Der opstod en fejl. Prøv igen.",
      variant: "error",
    });
  }
});

// Omdøb/slet ønskelister på kontosiden - genbruger nøjagtig de samme
// Worker-handlinger (renameList/deleteList) som skuffen allerede bruger,
// blot koblet til kontosidens egne knapper og gengivelsesfunktion. "Opret
// ny liste" håndteres nu i change-handleren for selve dropdownen ovenfor.
document.addEventListener("click", async (event) => {
  const renameListButton = event.target.closest("[data-wishlist-account-rename-list]");
  if (!renameListButton) return;

  const wishlistData = getWishlistData();
  const activeListId = getActiveListId(wishlistData);
  const activeList = wishlistData.lists.find((list) => list.id === activeListId);
  if (!activeList) return;

  const newName = await wishlistPrompt("Nyt navn på listen:", activeList.name);
  if (newName === null) return;

  try {
    const response = await fetch("/apps/onskeliste", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "renameList", listId: activeListId, name: newName }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serveren svarede ${response.status}: ${errorText}`);
    }

    await refreshWishlistAccountGrid();
  } catch (error) {
    console.error("Kunne ikke omdøbe liste:", error);
  }
});

document.addEventListener("click", async (event) => {
  const deleteListButton = event.target.closest("[data-wishlist-account-delete-list]");
  if (!deleteListButton) return;

  const confirmed = await wishlistConfirm("Er du sikker på du vil slette denne ønskeliste?");
  if (!confirmed) return;

  try {
    const response = await fetch("/apps/onskeliste");
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    const freshWishlist = await response.json();

    const activeListId = getActiveListId(freshWishlist);
    const activeList = freshWishlist.lists.find((list) => list.id === activeListId);
    if (!activeList) return;

    const remainingLists = freshWishlist.lists.filter((list) => list.id !== activeListId);
    const fallbackListId = remainingLists.length > 0 ? remainingLists[0].id : null;
    if (fallbackListId) setActiveListId(fallbackListId);

    const itemsContainer = document.querySelector("[data-wishlist-account-items]");
    const emptyState = document.querySelector("[data-wishlist-account-empty]");
    if (itemsContainer && emptyState) {
      renderWishlistAccountGrid({ lists: remainingLists }, emptyState, itemsContainer);
    }

    showWishlistPopup({
      messageParts: [
        { text: activeList.name, dynamic: true },
        { text: " er slettet." },
      ],
      actionText: "Fortryd",
      variant: "error",
      onAction: async () => {
        setActiveListId(activeListId);
        await refreshWishlistAccountGrid();
      },
      onTimeout: async () => {
        try {
          const deleteResponse = await fetch("/apps/onskeliste", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action: "deleteList", listId: activeListId }),
          });

          if (!deleteResponse.ok) {
            const errorText = await deleteResponse.text();
            throw new Error(`Serveren svarede ${deleteResponse.status}: ${errorText}`);
          }

          const updatedWishlist = await deleteResponse.json();
          const dataElement = document.getElementById("wishlist-data");
          if (dataElement) dataElement.textContent = JSON.stringify(updatedWishlist);
        } catch (error) {
          console.error("Kunne ikke slette liste:", error);
        }
      },
    });
  } catch (error) {
    console.error("Kunne ikke slette liste:", error);
  }
});
// ----------------------------------------------------------------------------------------------------------------------
// DEL ØNSKELISTE SOM PDF
// ----------------------------------------------------------------------------------------------------------------------
// Bygger en pænt opsat PDF af den aktive liste (billede, titel, variant, pris
// og et klikbart link pr. vare), så kunden kan dele den med familie/venner på
// tværs af mail/sms/messenger. jsPDF indlæses først når kunden rent faktisk
// trykker på knappen (ikke ved almindelig sideindlæsning), for ikke at
// belaste performance unødigt.
//
// Filen downloades automatisk med det samme, når kunden klikker på linket.

let wishlistJsPdfLoadingPromise = null;
let wishlistLogoDataUrlPromise = null;

function loadExternalScript(url) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${url}"]`);
    if (existing) {
      if (existing.dataset.wishlistLoaded === "true") {
        resolve();
        return;
      }
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error(`Kunne ikke indlæse ${url}`)));
      return;
    }

    const script = document.createElement("script");
    script.src = url;
    script.onload = () => {
      script.dataset.wishlistLoaded = "true";
      resolve();
    };
    script.onerror = () => reject(new Error(`Kunne ikke indlæse ${url}`));
    document.head.appendChild(script);
  });
}

function loadJsPdfLibrary() {
  if (!wishlistJsPdfLoadingPromise) {
    wishlistJsPdfLoadingPromise = loadExternalScript(
      "https://cdnjs.cloudflare.com/ajax/libs/jspdf/4.2.1/jspdf.umd.min.js"
    ).then(() => {
      if (!window.jspdf || !window.jspdf.jsPDF) {
        throw new Error("jsPDF blev indlæst, men window.jspdf.jsPDF findes ikke.");
      }
    });
  }
  return wishlistJsPdfLoadingPromise;
}

async function fetchImageAsDataUrl(imageUrl) {
  const response = await fetch(imageUrl, { mode: "cors" });
  if (!response.ok) throw new Error(`Kunne ikke hente billede: ${response.status}`);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

async function fetchProductImageAsDataUrl(imageUrl) {
  const separator = imageUrl.includes("?") ? "&" : "?";
  return fetchImageAsDataUrl(`${imageUrl}${separator}width=240&format=jpg`);
}

function getStellingLogoDataUrl() {
  if (!window.STELLING_LOGO_URL) return Promise.resolve(null);
  if (!wishlistLogoDataUrlPromise) {
    wishlistLogoDataUrlPromise = fetchImageAsDataUrl(window.STELLING_LOGO_URL).catch((error) => {
      console.error("Kunne ikke hente Stelling-logo til PDF:", error);
      return null;
    });
  }
  return wishlistLogoDataUrlPromise;
}

function sanitizeWishlistFilename(name) {
  return (
    (name || "onskeliste")
      .toLowerCase()
      .replace(/æ/g, "ae")
      .replace(/ø/g, "oe")
      .replace(/å/g, "aa")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || "onskeliste"
  );
}

// Faste PDF-tekster pr. sprog. Butikken bruger langify til oversættelser,
// men langify oversætter kun synlig DOM-tekst - selve PDF'en genereres
// direkte til en binær fil (jsPDF) og rammes derfor aldrig af langifys
// oversættelsesmotor. Da der reelt kun er meget få faste tekststrenge i
// PDF'en (varenavne kommer allerede som de er fra /apps/onskeliste), holder
// vi i stedet disse faste oversættelser her, valgt ud fra den sprogkode
// langify selv har registreret som aktiv (window.langify.locale.language_code).
const WISHLIST_PDF_STRINGS = {
  da: {
    headingWithName: "{name}'s kreative ønskeliste",
    headingWithoutName: "Din kreative ønskeliste",
    listNameFallback: "Ønskeliste",
    introText: "Velkommen til min kreative ønskeliste – tryk på et produkt for at se det på Stellings hjemmeside.",
    soldOutLabel: "Udsolgt i øjeblikket",
    productLinkText: "Se produktet",
  },
  en: {
    headingWithName: "{name}'s creative wishlist",
    headingWithoutName: "Your creative wishlist",
    listNameFallback: "Wishlist",
    introText: "Welcome to my creative wishlist – tap a product to see it on Stelling's website.",
    soldOutLabel: "Currently sold out",
    productLinkText: "View product",
  },
  sv: {
    headingWithName: "{name}s kreativa önskelista",
    headingWithoutName: "Din kreativa önskelista",
    listNameFallback: "Önskelista",
    introText: "Välkommen till min kreativa önskelista – tryck på en produkt för att se den på Stellings hemsida.",
    soldOutLabel: "Tillfälligt slutsåld",
    productLinkText: "Se produkten",
  },
  de: {
    headingWithName: "{name}s kreative Wunschliste",
    headingWithoutName: "Deine kreative Wunschliste",
    listNameFallback: "Wunschliste",
    introText: "Willkommen zu meiner kreativen Wunschliste – tippe auf ein Produkt, um es auf Stellings Website anzusehen.",
    soldOutLabel: "Aktuell ausverkauft",
    productLinkText: "Produkt ansehen",
  },
};

// Læser den sprogkode, langify selv har registreret som aktiv lige nu.
// Falder tilbage til dansk, hvis langify af en eller anden grund ikke er
// indlæst, eller hvis det registrerede sprog ikke findes i listen ovenfor.
function getWishlistPdfStrings() {
  let languageCode = "da";
  try {
    if (window.langify && window.langify.locale && window.langify.locale.language_code) {
      languageCode = window.langify.locale.language_code;
    }
  } catch (error) {
    languageCode = "da";
  }
  return WISHLIST_PDF_STRINGS[languageCode] || WISHLIST_PDF_STRINGS.da;
}

async function buildWishlistPdf(list) {
  await loadJsPdfLibrary();
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: "mm", format: "a4" });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;
  const imageSize = 28;
  const rowGap = 8;
  const textX = margin + imageSize + 6;
  const textWidth = pageWidth - margin - textX;
  const brandDark = [70, 52, 29];
  const brandGold = [151, 123, 62];
  const subduedGray = [110, 110, 110];

  const [imageDataUrls, logoDataUrl] = await Promise.all([
    Promise.all(
      list.items.map((item) =>
        item.image
          ? fetchProductImageAsDataUrl(item.image).catch((error) => {
              console.error("Kunne ikke hente ønskeliste-billede til PDF:", error);
              return null;
            })
          : Promise.resolve(null)
      )
    ),
    getStellingLogoDataUrl(),
  ]);

  let y = margin;
  const logoSize = 22;

  if (logoDataUrl) {
    try {
      doc.addImage(logoDataUrl, "PNG", margin, y, logoSize, logoSize, undefined, "FAST");
    } catch (error) {
      console.error("Kunne ikke indsætte Stelling-logo i PDF:", error);
    }
  }

  const strings = getWishlistPdfStrings();

  const headingX = logoDataUrl ? margin + logoSize + 6 : margin;
  const firstName = (window.STELLING_CUSTOMER_FIRST_NAME || "").trim();
  const headingText = firstName
    ? strings.headingWithName.replace("{name}", firstName)
    : strings.headingWithoutName;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(...brandDark);
  doc.text(headingText, headingX, y + 9);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(...subduedGray);
  doc.text(list.name || strings.listNameFallback, headingX, y + 16);

  y += Math.max(logoSize, 20) + 6;

  doc.setDrawColor(...brandGold);
  doc.setLineWidth(0.6);
  doc.line(margin, y, pageWidth - margin, y);
  y += 8;

  const introText = strings.introText;
  doc.setFont("helvetica", "italic");
  doc.setFontSize(10);
  doc.setTextColor(...subduedGray);
  const introLines = doc.splitTextToSize(introText, pageWidth - margin * 2);
  doc.text(introLines, margin, y + 4);
  y += introLines.length * 5 + 6;

  doc.setFont("helvetica", "normal");

  list.items.forEach((item, index) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    const titleLines = doc.splitTextToSize(item.title || "Produkt", textWidth);

    let textBlockHeight = titleLines.length * 5;
    if (item.variant_title) textBlockHeight += 5;
    textBlockHeight += 5;
    if (item.available === false) textBlockHeight += 5;
    if (item.url) textBlockHeight += 5;

    const rowHeight = Math.max(imageSize, textBlockHeight) + rowGap;

    if (y + rowHeight > pageHeight - margin) {
      doc.addPage();
      y = margin;
    }

    // Beregnes tidligt, så både billede og titel kan gøres klikbare.
    const productUrl = item.url
      ? item.url.startsWith("http")
        ? item.url
        : `${window.location.origin}${item.url}`
      : null;

    const imageDataUrl = imageDataUrls[index];
    if (imageDataUrl) {
      try {
        doc.addImage(imageDataUrl, "JPEG", margin, y, imageSize, imageSize, undefined, "FAST");
      } catch (error) {
        console.error("Kunne ikke indsætte billede i PDF:", error);
      }
    }
    if (productUrl) {
      // Billedet skal være klikbart og føre til produktet.
      doc.link(margin, y, imageSize, imageSize, { url: productUrl });
    }

    let textY = y + 5;
    const titleTop = textY - 4;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(20, 20, 20);
    doc.text(titleLines, textX, textY);
    textY += titleLines.length * 5;

    if (productUrl) {
      // Titlen skal også være klikbar og føre til produktet.
      doc.link(textX, titleTop, textWidth, textY - 1 - titleTop, { url: productUrl });
    }

    if (item.variant_title) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9.5);
      doc.setTextColor(90, 90, 90);
      doc.text(item.variant_title, textX, textY);
      textY += 5;
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(...brandDark);
    doc.text(`${item.price} kr.`, textX, textY);
    textY += 5;

    if (item.available === false) {
      doc.setFont("helvetica", "italic");
      doc.setFontSize(8.5);
      doc.setTextColor(191, 21, 21);
      doc.text(strings.soldOutLabel, textX, textY);
      textY += 5;
    }

    if (productUrl) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(...brandDark);
      doc.textWithLink(strings.productLinkText, textX, textY, { url: productUrl });
    }

    y += rowHeight;
  });

  return doc;
}

async function handleShareWishlistPdfClick(link) {
  if (link.dataset.loading === "true") return;

  link.dataset.loading = "true";
  const originalOpacity = link.style.opacity;
  link.style.opacity = "0.5";
  link.setAttribute("aria-busy", "true");

  try {
    const response = await fetch("/apps/onskeliste");
    if (!response.ok) throw new Error(`Serveren svarede ${response.status}`);
    const freshWishlist = await response.json();

    const activeListId = getActiveListId(freshWishlist);
    const activeList = freshWishlist.lists.find((list) => list.id === activeListId);

    if (!activeList || activeList.items.length === 0) {
      showWishlistPopup({
        message: "Der er ingen varer på listen at dele endnu.",
        variant: "error",
      });
      return;
    }

    const doc = await buildWishlistPdf(activeList);
    const filename = `stelling-onskeliste-${sanitizeWishlistFilename(activeList.name)}.pdf`;

    // Downloader altid filen med det samme, uanset om enheden også kan vise
    // et del-vindue - kunden har filen liggende, selv hvis del-vinduet
    // fejler, afvises, eller ikke understøttes af enheden.
    doc.save(filename);

    // Viser derudover enhedens eget del-vindue ved siden af (fx til
    // Messenger/SMS/Mail på mobil), hvis den understøtter det. Kører i sin
    // egen try/catch, så en afvisning eller manglende understøttelse ikke
    // udløser fejl-popup'en nedenfor - filen er jo allerede downloadet.
    try {
      const pdfBlob = doc.output("blob");
      const pdfFile = new File([pdfBlob], filename, { type: "application/pdf" });
      if (navigator.canShare && navigator.canShare({ files: [pdfFile] })) {
        await navigator.share({
          files: [pdfFile],
          title: activeList.name || "Min ønskeliste",
          text: "Se min ønskeliste hos Stelling",
        });
      }
    } catch (shareError) {
      if (!shareError || shareError.name !== "AbortError") {
        console.error("Kunne ikke åbne del-vinduet:", shareError);
      }
    }
  } catch (error) {
    console.error("Kunne ikke generere PDF af ønskelisten:", error);
    showWishlistPopup({
      message: "Der opstod en fejl under generering af PDF'en. Prøv igen.",
      variant: "error",
    });
  } finally {
    link.dataset.loading = "false";
    link.style.opacity = originalOpacity;
    link.removeAttribute("aria-busy");
  }
}

document.addEventListener("click", (event) => {
  const shareLink = event.target.closest("[data-wishlist-share-pdf], [data-wishlist-account-share-pdf]");
  if (!shareLink) return;

  event.preventDefault();
  handleShareWishlistPdfClick(shareLink);
});